// English. Every key here must exist in es.js and pt.js (messages.test.js checks).
export default {
  languages: {
    English: 'English',
    Spanish: 'Spanish',
    Portuguese: 'Portuguese',
    French: 'French',
    German: 'German',
    Italian: 'Italian',
    Arabic: 'Arabic',
    Russian: 'Russian',
    Japanese: 'Japanese',
    Korean: 'Korean',
    Hindi: 'Hindi',
    Chinese: 'Chinese',
    Bengali: 'Bengali',
    Indonesian: 'Indonesian',
    Turkish: 'Turkish',
    Urdu: 'Urdu',
    Tamil: 'Tamil',
    Persian: 'Persian',
    Romanian: 'Romanian',
    Filipino: 'Filipino',
    Kazakh: 'Kazakh',
  },

  styles: {
    realistic: { label: 'Realistic', description: 'Highly detailed, true-to-life art style' },
    cinematic: { label: 'Cinematic', description: 'Movie-like dramatic scenes' },
    '3d-animation': { label: '3D Cartoon', description: 'Animated-film 3D look, as pictures' },
    cartoon: { label: 'Cartoon', description: 'Bold outlines, flat bright colors' },
    'comic-book': { label: 'Comic Book', description: 'Ink outlines and halftone, like a graphic novel' },
    storybook: { label: 'Storybook', description: 'Warm picture-book illustration' },
    'anime-realism': { label: 'Anime Realism', description: 'Gritty realistic anime' },
    anime: { label: 'Anime', description: 'Stylized Japanese art style with expressive eyes' },
    'dreamy-anime': { label: 'Dreamy Anime', description: 'Hand-painted anime film, lush and warm' },
    'oil-portrait': { label: 'Oil Portrait', description: 'Renaissance-style, rich textures' },
    watercolor: { label: 'Watercolor', description: 'Pastel colors, painterly texture' },
    'ink-sketch': { label: 'Ink Sketch', description: 'Black ink, cross-hatching' },
    'pop-art': { label: 'Pop Art', description: 'High-contrast, bold colors' },
    collage: { label: 'Collage', description: 'Layered handcrafted composition' },
    'paper-cutout': { label: 'Paper Cutout', description: 'Layered paper, simple shapes' },
    'ukiyo-e': { label: 'Ukiyo-e', description: 'Japanese woodblock print' },
    kawaii: { label: 'Kawaii', description: 'Kawaii style with cute, pastel-colored features' },
    claymation: { label: 'Claymation', description: 'Stop-motion clay figures' },
    'pixel-art': { label: 'Pixel Art', description: 'Retro 16-bit game pixels' },
    'low-poly': { label: 'Low Poly', description: 'Faceted 3D, indie game look' },
    'fantasy-epic': { label: 'Fantasy Epic', description: 'Magic, castles, high-fantasy' },
    cyberpunk: { label: 'Cyberpunk', description: 'Glowing lights, futuristic city vibes' },
    'vintage-retro': { label: 'Vintage Retro', description: '70s/80s/90s inspired, warm tones' },
    'noir-film': { label: 'Noir Film', description: 'Black-and-white, dramatic lighting' },
    spooky: { label: 'Spooky', description: 'Dark, eerie style with sharp contrasts' },
  },

  // A narrator's voice: a man's or a woman's (i18n/narration.js VOICE_GENDERS)
  voiceGender: {
    man: 'Man',
    woman: 'Woman',
  },
  voices: {
    alloy: 'Neutral and balanced, clear and versatile',
    ash: 'Soft, conversational with a warm tone',
    ballad: 'Gentle, expressive, and melodic',
    coral: 'Warm, friendly mid-range voice',
    echo: 'Clear and resonant, slightly formal',
    fable: 'Expressive, storytelling quality',
    nova: 'Energetic, youthful, and bright',
    onyx: 'Deep, authoritative, and commanding',
    sage: 'Calm, thoughtful, and wise',
    shimmer: 'Light, upbeat, and enthusiastic',
    verse: 'Articulate, polished narrator voice',
    puck: 'Upbeat and playful, great for fun facts',
    kore: 'Firm and confident, made for explainers',
    fenrir: 'Excited and fast, for hype and sports',
    aoede: 'Breezy and light, for lifestyle and travel',
    enceladus: 'Low and breathy, for horror and mystery',
    algenib: 'Gravelly and dramatic, like a movie trailer',
    despina: 'Smooth and polished, for luxury and brands',
    achernar: 'Soft and soothing, for calm and bedtime stories',
    zephyr: 'Bright and cheerful, for kids and tutorials',
    sadaltager: 'Knowledgeable, like a documentary host',
    zubenelgenubi: 'Casual and relaxed, like talking to a friend',
    pulcherrima: 'Bold and direct, for motivation',
  },

  sidebar: {
    label: 'App',
    home: 'Home',
    create: 'Create',
    fromVideo: 'From a video',
    collapse: 'Fold the sidebar',
    expand: 'Open the sidebar',
    managePlan: 'Manage plan',
  },
  dashboard: {
    seoTitle: 'Home',
    kicker: 'Home',
    title: 'What are we making today?',
    titleNamed: 'What are we making today, {name}?',
    subtitle: 'Write an idea and the AI Agent makes the video. Or start from a video you have.',
    placeholder: 'Describe your video in one sentence…',
    make: 'Make',
    recent: 'Recent',
    seeAll: 'See all',
    empty: 'Nothing yet. Your first video starts with a sentence above.',
    ready: 'Ready',
    making: 'Making',
    failed: 'Failed',
    untitled: 'Untitled',
  },
  nav: {
    features: 'Features',
    pricing: 'Pricing',
    login: 'Log in',
    getStarted: 'Get Started',
    getStartedFree: 'Get Started Free',
    create: 'Create',
    menu: 'Menu',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'Same as the device',
    usage: 'Usage',
    videoMinutes: 'Video Minutes',
    aiAgentVideos: 'AI Agent Videos',
    upgrade: 'Upgrade to Pro',
    myAccount: 'My Account',
    admin: 'Admin Dashboard',
    logout: 'Logout',
    user: 'User',
    tools: 'Tools',
    minutesLeft: 'You have {n} video processing minutes left.',
    minutesUnlimited: 'You have unlimited video processing minutes.',
    agentLeft: 'You have {n} AI Agent videos left.',
    trialShort: '{n}d trial',
    trialEnds: 'Trial ends {date}',
    trialLeftOne: '{n} day left in trial',
    trialLeftMany: '{n} days left in trial',
    badgeNew: 'New',
    badgeBeta: 'Beta',
  },
  tools: {
    aiClipping: 'AI Clipping',
    captions: 'Captions',
    reframe: 'Reframe',
    editor: 'Editor',
    aiAgent: 'AI Agent',
  },
  featureLinks: {
    aiClipping: { label: 'AI Clipping', description: 'Transform long videos into viral shorts' },
    autoCaption: { label: 'Auto Caption', description: 'Generate styled captions for any video' },
    reframe: { label: 'AI Video Reframe', description: 'Reframe full videos with smart cropping' },
    aiAgent: { label: 'AI Agent', description: 'Create videos from ideas with AI' },
    editor: { label: 'Online Video Editor', description: 'Professional editing in your browser' },
  },
  createActions: {
    aiClipping: { label: 'AI Clipping', description: 'Extract viral moments from videos' },
    autoCaption: { label: 'Auto Caption', description: 'Add styled captions to videos' },
    reframe: { label: 'Video Reframe', description: 'Smart crop & resize videos' },
    aiAgent: { label: 'AI Agent', description: 'Create videos from ideas' },
    scenes: { label: 'Scenes', description: 'One animated shot with sound and voices' },
    editor: { label: 'Video Editor', description: 'Edit videos in your browser' },
    series: {
      label: 'Series',
      description: 'New videos on a schedule or on demand',
    },
    characters: { label: 'Characters', description: 'A cast that looks the same in every video' },
  },

  footer: {
    monetizeGuide: 'Monetize AI videos',
    clipYtShorts: 'YouTube to Shorts',
    clipPodcasts: 'Podcast clips',
    clipStreams: 'Stream clips',
    clipClippers: 'For clippers',
    canalDarkGuide: 'Start a faceless channel',
    company: 'Company',
    about: 'About Clip-Short',
    videoReframe: 'Video Reframe',
    videoEditor: 'Video Editor',
    faq: 'FAQ',
    affiliates: 'Affiliate program',
    privacy: 'Privacy policy',
    cookies: 'Cookie preferences',
    signUp: 'Sign up',
    language: 'Language',
    copyright: '© {year} Clip-Short.com - AI-Powered Video Editing Platform',
    tools: 'Tools',
    freeTools: 'Free tools',
    guides: 'Guides',
    compareUseCases: 'Compare & use cases',
    characters: 'Characters',
    remix: 'Remix',
    scenes: 'Scenes',
    yourProjects: 'Your projects',
    account: 'Account',
  },

  consent: {
    title: 'We use cookies for analytics and to measure our ads',
    allow: 'Allow cookies',
    decline: 'Decline',
    manage: 'Manage preferences',
    learnMore: 'Learn more in our',
    policy: 'Privacy & Cookie Policy',
    dialogTitle: 'Privacy preferences',
    dialogBody: 'Control which optional cookies and storage we use. Essential data (for authentication and UI preferences) always stays enabled.',
    dialogBodyShort: 'Control optional cookies. Essential data always stays enabled.',
    analytics: 'Analytics',
    analyticsBody: 'Allow PostHog and Vercel Speed Insights to capture product usage trends, and Google Ads to tell us whether our ads brought you here. These help us improve features and performance without identifying you directly.',
    analyticsBodyShort: 'Help us improve features and performance, and measure our ads.',
    toggle: 'Toggle analytics cookies',
    readMore: 'Read more about how we use cookies and data in our',
    revisit: 'You can revisit these settings at any time from the navigation menu or banner link.',
    revisitShort: 'Change settings anytime from the menu.',
    reset: 'Reset decision',
    close: 'Close',
  },

  agentFormats: {
    label: 'Format',
    story: 'Story',
    countdown: 'Top 5 countdown',
    quiz: 'Quiz / would you rather',
    chat: 'Text-chat story',
    pov: 'POV: you\'re there',
  },
  publish: {
    posted: {
      title: 'Posted it?',
      hint: 'Mark where you posted it, to keep track.',
      seriesHint: 'Mark where you posted it. The series leans its next ideas toward the episodes you post.',
      since: 'Marked posted on {day}',
      failed: "Couldn't save that. Try again.",
    },
    button: 'Post',
    title: 'Post this video',
    subtitle: 'Words written for each platform in your video\'s language. Edit them, copy them, and post.',
    platforms: 'Platforms',
    writing: 'Writing the post…',
    writeFailed: 'Couldn\'t write the post. Try again.',
    copy: 'Copy text',
    copied: 'Copied',
    copyOne: 'Copy',
    copyAll: 'Copy all',
    rewrite: 'Write again',
    write: 'Write the post words',
    aiLabel: 'On YouTube, turn on "Altered or synthetic content" if the video shows realistic AI people or events.',
    shareToApp: 'Send to the app',
    shareGettingReady: 'Getting the video ready…',
    shareFailed: 'Your phone did not take the video. Save it to your device, then upload it in the app.',
    openPlatform: 'Open {platform}',
    scheduleTitle: 'Post later',
    scheduleHint: 'We\'ll email you the video and these words at that time.',
    schedule: 'Remind me',
    scheduleFailed: 'Couldn\'t schedule it. Pick a time within the next 60 days.',
    cancel: 'Cancel',
    platform: {
      tiktok: 'TikTok',
      youtube: 'YouTube Shorts',
      instagram: 'Instagram Reels',
      facebook: 'Facebook Reels',
    },
    fields: {
      title: 'Title',
      description: 'Description',
      caption: 'Caption',
      tags: 'Tags',
    },
    shareSubtitle: 'Words for each platform, a reminder for later, and a link anyone can open.',
  },
  usageLimit: {
    title: "You've reached this month's limit",
    minutes: "You've used this period's video minutes.",
    aiVideos: "You've used this period's AI videos.",
    upgrade: "A bigger plan gives you more each month.",
    close: "Close",
    pricing: "See plans",
  },
  translateVideo: {
    versions: "In other languages:",
    original: "See the original",
    translating: "Translating…",
    button: 'Translate',
    title: 'Make it in another language',
    subtitle: 'The same pictures, the narration and on-screen words translated and voiced again with the same voice.',
    costsOne: 'It\'s a new video, so it uses one AI video from your plan.',
    make: 'Make the video',
    failed: 'Couldn\'t start the translation. Try again.',
    outOfVideos: "You have no AI videos left. Upgrade to make more.",
  },
  // Your own voice (components/voices, api/services/voices.py): made only from the user
  // reading today's sentence aloud, so it can only ever be their own voice
  ownVoice: {
    group: 'Your voices',
    record: 'Record your voice',
    recordHint: 'Narrate your videos in your own voice',
    paidOnly: 'Your own voice is on paid plans',
    upgrade: 'See plans',
    slow: 'Your own voice takes longer: about 5 minutes per minute of narration, for videos up to {minutes} minutes.',
    tooLong: 'Your own voice narrates videos up to {minutes} minutes. Pick a shorter length or another voice.',
    play: 'Play {name}',
    sampleMaking: 'Making a sample in this voice…',
    dialog: {
      title: 'Record your voice',
      subtitle: 'Read one sentence aloud and we make your voice from it. It can narrate your videos in English, Spanish, Portuguese, Arabic and more.',
      ownOnly: 'Only record your own voice. The sentence you read is your agreement, and it has new words every time, so nobody else\'s recording can be used.',
      language: 'The language you\'ll read in',
      name: 'Name (optional)',
      namePlaceholder: 'My voice',
      getSentence: 'Show me the sentence',
      readThis: 'Read this aloud, in your normal voice:',
      start: 'Start recording',
      stop: 'Stop',
      recording: 'Recording… {seconds} s',
      again: 'Record again',
      save: 'Save my voice',
      saving: 'Checking your recording…',
      saved: 'Your voice is ready. Pick it as the narrator.',
      tips: 'A quiet room, your phone or microphone a hand away, 10 to 20 seconds.',
    },
    errors: {
      microphone: 'We couldn\'t use your microphone. Allow it in the browser and try again.',
      micBlocked: 'Your browser blocked the microphone. Allow it for clip-short.com (the icon at the start of the address bar), then try again.',
      micBlockedIos: 'Your iPhone blocked the microphone. In Safari: tap the page menu in the address bar, then Website Settings, then Microphone: Allow. In Chrome: open the Settings app, then Chrome, and turn on Microphone. Then try again.',
      micMissing: 'We found no microphone. Connect one and try again.',
      micBusy: 'Another app is using the microphone (a call or a recorder). Close it and try again.',
      sentence_not_heard: 'We couldn\'t hear the whole sentence, with the three words at the end. Read it again, a bit closer to the microphone.',
      too_short: 'That was too short. Read the whole sentence; it takes about 10 seconds.',
      consent_expired: 'That sentence expired. Here\'s a new one.',
      unreadable_recording: 'We couldn\'t read that recording. Try again.',
      too_many_voices: 'You have 3 voices already. Delete one under Account, Voices, to make another.',
      paid_plan_required: 'Your own voice is on paid plans.',
      voice_unavailable: 'Recording voices isn\'t available right now. Try again later.',
      voice_not_found: 'That voice was deleted. Pick another one.',
      own_voice_too_long: 'Your own voice narrates videos up to 3 minutes. Pick a shorter length or another voice.',
      generic: 'Something went wrong. Try again.',
    },
    account: {
      nav: 'Voices',
      title: 'Your voices',
      subtitle: 'Voices made from your own recording. Only you can use them.',
      empty: 'No voices yet.',
      delete: 'Delete',
      deleteQuestion: 'Delete this voice? Videos you already made keep their sound.',
      deleteConfirm: 'Delete it',
      keep: 'Keep it',
      recorded: 'Recorded in {language}',
    },
  },
  // The AI Agent's three places (components/AIAgent/AIAgentTabs.jsx)
  // A quiet line under the AI Agent's tabs (components/AIAgent/ClipsCard.jsx)
  clipsCard: {
    title: 'Have a long video?',
    text: 'AI Clipping cuts it into short clips with captions.',
    button: 'Get clips',
    close: 'Close',
  },
  aiAgentTabs: {
    video: 'Video',
    scenes: 'Scenes',
    label: 'AI Agent',
    create: 'Create a video',
    series: 'Series',
    characters: 'Characters',
  },
  // A recurring cast (pages/CharactersPage.jsx, components/characters): drawn once, the
  // same face in every picture of every video and series episode that picks them
  characters: {
    title: 'Characters',
    subtitle: 'Your recurring cast. Describe a character once and they look the same in every scene, every video and every episode.',
    new: 'New character',
    yours: 'Your cast ({n} of {max})',
    yoursUncapped: 'Your cast ({n})',
    loadError: "Couldn't load your characters. Refresh the page to try again.",
    emptyTitle: 'Create your first character',
    emptyText: 'A hero for your stories, a host for your channel, a mascot for your brand.',
    deleteTitle: 'Delete {name}?',
    deleteText: 'Videos you already made keep their pictures. Series with this character go on without them.',
    keep: 'Keep',
    delete: 'Delete',
    demo: {
      kicker: 'Character consistency',
      title: 'The same character, every scene',
      text: 'AI pictures usually change a face from one scene to the next. A character is drawn once as a reference, and every picture they appear in is drawn from it.',
      steps: {
        describe: 'Describe how they look: age, face, hair, clothes, colours.',
        draw: 'We draw their reference portrait. Draw it again until it is right.',
        use: 'Pick them for a video or a whole series.',
      },
      frames: {
        portrait: 'The reference',
        scene1: 'Scene 1',
        scene2: 'Scene 4',
      },
    },
    card: {
      edit: 'Edit {name}',
      delete: 'Delete {name}',
      video: 'Use in a video',
      series: 'Start a series',
    },
    dialog: {
      newTitle: 'New character',
      editTitle: 'Edit {name}',
      subtitle: "Describe what always stays the same about them. Their portrait becomes the reference for every picture they're in.",
      name: 'Name',
      namePlaceholder: 'Nour',
      look: 'How they look',
      lookPlaceholder: 'A 10-year-old girl with curly black hair tied back, a green scarf, a yellow t-shirt and denim overalls, brave brown eyes',
      lookHint: 'Age, face, hair, build, clothes and colours. The more specific, the more they stay the same.',
      style: 'Drawn in',
      preview: 'Their portrait appears here.',
      drawing: 'Drawing {name}… about 15 seconds',
      drawingShort: 'Drawing…',
      portraits: 'Every drawing so far. Tap one to use it.',
      portraitInUse: 'In use',
      portraitPick: 'Use drawing {n}',
      consistent: 'This portrait is what keeps them the same in every picture. Draw it again until it is right.',
      draw: 'Draw character',
      redraw: 'Draw again',
      redrawChanged: 'Draw with changes',
      done: 'Done',
      picture: 'Start from a picture (optional)',
      pictureHint: 'Upload a drawing, a pet, a mascot, or a photo of yourself',
      pictureLooking: 'Looking at your picture…',
      pictureOther: 'We wrote how they look from your picture. Change anything below.',
      picturePerson: 'A photo of a person is always drawn as an illustration, in one of the drawn styles.',
      pictureConsent: 'This is me, or I have their permission to use their photo.',
      pictureRemove: 'Remove the picture',
      styleIllustratedOnly: 'Drawn from a photo of a person, so photographic styles are off.',
    },
    ideas: {
      girl: { label: 'A young explorer', name: 'Nour', look: 'A 10-year-old girl with curly black hair tied back, a green scarf, a yellow t-shirt and denim overalls, brave brown eyes' },
      grandfather: { label: 'A storyteller', name: 'Grandpa Sam', look: 'A kind old man with a short white beard, round glasses, a brown knitted cardigan over a white shirt, warm smile' },
      detective: { label: 'A detective', name: 'Detective Vale', look: 'A woman in her 40s with short silver hair, a long charcoal coat, a red scarf, sharp grey eyes' },
      robot: { label: 'A robot sidekick', name: 'Bolt', look: 'A small round robot with a white shell, one big blue glowing eye, short orange antennae and little wheels' },
    },
    picker: {
      label: 'Characters',
      optional: '(optional)',
      manage: 'Manage',
      remove: 'Remove {name}',
      add: 'Add a character',
      create: 'Create a character',
      hint: 'Add a recurring character and they look the same in every picture.',
      chosenHint: 'They look the same in every picture. Name them in your idea to give them a part.',
      seriesHint: 'Each episode follows one of them, taking turns: up to {max} in a series. Tap a name to change them.',
      title: 'Choose characters',
      subtitle: 'Up to {max}. Each one keeps one face in every picture.',
      seriesHintAny: 'Each episode follows the ones its idea names, taking turns. Tap a name to change them.',
      subtitleAny: 'Each one keeps one face in every picture.',
      new: 'New character',
      done: 'Done',
    },
    errors: {
      character_incomplete: 'Give them a name and describe how they look in a sentence or two.',
      too_many_characters: 'You have 12 characters. Delete one to make another.',
      name_taken: 'You already have a character with that name.',
      too_many_portraits: "That's today's portraits. Try again tomorrow.",
      portrait_failed: "Couldn't draw that portrait. Try again, or change the description.",
      character_not_found: 'One of the characters was deleted. Pick another.',
      photo_of_a_child: 'We don\'t make characters from photos of children. Describe them instead, or upload a drawing.',
      photo_consent_needed: 'Tick the box to confirm the photo is you, or that you have their permission.',
      photo_needs_illustrated_style: 'A photo of a person is only drawn in an illustrated style. Pick another style.',
      picture_unreadable: 'We couldn\'t read that picture. Try a JPG or PNG.',
      picture_too_large: 'That picture is too large. Try one under 8 MB.',
      too_many_looks: 'That\'s today\'s pictures. Try again tomorrow.',
      look_failed: 'We couldn\'t look at that picture. Try again.',
      generic: 'Something went wrong. Try again.',
    },
  },
  // A series of AI Agent videos drafted on a schedule (pages/SeriesPage.jsx): every
  // episode waits for its owner, and its originality is an estimate, never YouTube's decision
  series: {
    title: 'Series',
    subtitle: "Your channel's next videos: a new episode on your topic, on the schedule you pick, each with a new angle.",
    promise: 'Every episode waits for you. Nothing is posted until you review it and post it yourself.',
    back: 'AI Agent',
    link: 'Make it a series',
    linkHint: 'A new episode on a schedule, waiting for your review',
    how: {
      review: { title: 'You post, not us', text: 'Each episode is drafted and emailed to you. Watch it, change it, then post it when you want.' },
      angles: { title: 'A new angle each time', text: 'Every episode takes a different story, fact or angle on your topic, never a repeat.' },
      check: { title: 'An originality check', text: 'Each episode is compared with your earlier ones, and we warn you before the series turns repetitive.' },
    },
    form: {
      title: 'Start a series',
      topic: 'What is the channel about?',
      topicPlaceholder: 'Legends and myths from ancient Egypt, told for adults. One legend per video, true to how it is really told.',
      topicHint: 'Each episode takes a different story, fact or angle on this.',
      topicTooShort: 'Describe the channel in a sentence or two.',
      name: 'Series name (optional)',
      namePlaceholder: 'Egyptian legends',
      format: 'Format',
      style: 'Visual style',
      language: 'Narration language',
      voice: 'Narrator',
      duration: 'Length',
      aspect: 'Shape',
      cadence: 'How often',
      start: 'First episode',
      startNow: 'Now',
      startLater: 'At a time I pick',
      cost: 'Each episode uses one of your plan\'s AI videos. If they run out, the series pauses and we email you.',
      submit: 'Start the series',
      creating: 'Starting…',
      freeLength: 'Series are a Pro feature: upgrade to make this series.',
      tooMany: 'You have 10 series already. Stop one to start another.',
      error: 'Couldn\'t start the series. Check the fields and try again.',
    },
    cadence: {
      24: 'Every day',
      48: 'Every other day',
      56: '3 times a week',
      168: 'Every week',
    },
    status: {
      active: 'Active',
      paused: 'Paused',
    },
    paused: {
      unreviewed: "Paused: 5 finished episodes are waiting for you. Watch one and the series carries on.",
      voice: 'Paused: its narrator voice was deleted. Pick another, then resume.',
      user: 'Paused by you.',
      out_of_videos: 'Paused: your plan has no AI videos left this period. Resume it when they renew, or upgrade.',
      pro: "Paused: series are a Pro feature. Your episodes are all here; go Pro to carry on.",
      goPro: "Go Pro",
      out_of_minutes: 'Paused: your plan has no minutes left. Resume it when they renew, or upgrade.',
      longer_than_plan: 'Paused: your plan makes 30-second videos. Make the episodes shorter, or upgrade.',
      videosBack: 'Your AI videos are back: {n} left. Resume the series to carry on.',
      account: 'Paused.',
    },
    settings: {
      cast: 'Cast',
      noCast: 'No recurring character',
      changeCast: 'Change the cast',
      castTitle: "The series' cast",
      castHint: 'Every picture that names them draws them the same. The next episodes follow; the ones made keep theirs.',
      look: 'Look',
      changeLook: 'Change the look',
      lookTitle: "The series' look",
      lookHint: 'The next episodes start with these. The ones made keep theirs.',
      noTitleCard: 'No title cards',
      schedule: 'Schedule',
      changeSchedule: 'Change the schedule',
      failed: "Couldn't save. Try again.",
    },
    page: {
      numbers: {
        made: 'Episodes made',
        waiting: 'Waiting for you',
        posted: 'Posted',
        liked: 'Liked',
      },
    },
    ready: {
      title: 'Episode {n} is ready',
      watch: 'Watch',
      dismiss: 'Dismiss',
    },
    list: {
      steps: {
        script: 'Writing the script',
        pictures: 'Drawing the pictures and recording the voice',
        together: 'Putting it together',
        finishing: 'Finishing',
      },
      title: 'Your series',
      empty: 'No series yet. Start one above: the first episode is drafted within a minute, or at the time you pick.',
      loadError: 'Couldn\'t load your series. Refresh the page to try again.',
      noEpisodes: 'The first episode will be drafted at the time you picked.',
      next: 'Next episode: {when}',
      nextSoon: 'The next episode is being drafted now.',
      episode: 'Ep. {n}',
      pause: 'Pause',
      resume: 'Resume',
      delete: "Delete series",
      deleteConfirm: 'No more episodes will be drafted. The episodes already made stay in your projects.',
      keep: 'Keep it',
    },
    episodeState: {
      posted: 'Posted',
      reviewed: 'Reviewed',
      drafting: 'Drafting…',
      ready: 'Ready to review',
      failed: 'Failed',
    },
    check: {
      okBadge: 'Reads original',
      warnBadge: "Too similar",
      ok: 'Reads different from your last {n} episodes: its title, idea and opening words.',
      first: 'The first episode: nothing to compare it with yet.',
      advice: 'Rewrite its first lines or give it another angle before you post it: repeated openings and templates are what YouTube calls inauthentic content.',
      disclaimer: 'An estimate from the words of your episodes, not YouTube\'s decision.',
      reasons: {
        same_title: 'Its title is almost the same as episode {episode}\'s.',
        same_idea: 'Its idea is close to episode {episode}\'s.',
        opening: 'It opens almost word for word like episode {episode}.',
        openings: '{similar} of your last {n} episodes open almost the same way.',
        titles: '{similar} of your last {n} titles follow one pattern.',
      },
    },
    look: {
      titleCard: 'Title cards',
      title: "The series' look: new episodes start with these captions and this music. Change them on any episode.",
      captions: 'Captions: {name}',
      customCaptions: 'Custom',
      noCaptions: 'No captions',
      music: 'Music: {name}',
      noMusic: 'No music',
    },
    alsoIn: {
      label: 'Also make every episode in',
      hint: 'Up to {max} more languages: the same pictures, narrated again. Each one uses one more AI video from your plan.',
      summary: 'Also in {languages}, one more AI video each',
      chip: 'Also in {languages}',
      versions: "Other languages",
      failed: "Couldn't be made",
      translating: 'Translating…',
      skipped: 'Not made: no AI videos left',
      skippedOther: "Couldn't be made",
    },
    inspiration: {
      open: 'Start from a channel you like',
      openHint: 'its niche, your own angle',
      label: 'A YouTube channel you like',
      placeholder: 'youtube.com/@channel or @channel',
      suggest: 'Suggest',
      reading: 'Reading the channel…',
      close: 'Close',
      filled: 'Filled in from {channel}: its niche, your own angle. Change anything.',
      whatWorks: 'What works there:',
      different: 'Yours is different:',
      firstIdeas: 'First episodes could be:',
      errors: {
        bad_link: "That isn't a YouTube channel or video link.",
        not_found: 'YouTube has no channel at that link.',
        no_videos: 'That channel has no public videos to read.',
        unavailable: "This isn't available right now.",
        too_many: "That's enough channels for today. Try again tomorrow.",
        other: "Couldn't read that channel. Try again.",
      },
    },
    calendar: {
      title: 'Coming up',
      hint: "The next 7 days across your series, and your reminders to post.",
      today: 'Today',
      tomorrow: 'Tomorrow',
      newIdea: 'A new idea',
      post: 'Post: {title}',
      yourVideo: 'your video',
      dragHint: "Drag an episode to another day to change when it is made, or use its Move button. The episodes after it in that series move with it.",
      touchHint: "Tap Move on an episode to change the day it is made. The episodes after it in that series move with it.",
      move: "Move",
      moveTo: "Move to",
      moved: "Moved to {day} ({time}). The episodes after it in that series move with it.",
      moveFailed: "It couldn't be moved. Try again.",
      grip: "Drag to another day",
    },
    autoExport: {
      label: 'Export each episode for me',
      hint: "Every episode arrives as a finished video in the series' look, ready to download and post. You can still change it and export again.",
      chip: 'Exported for you',
      exporting: 'Exporting…',
      download: 'Download',
    },
    create: {
      title: 'Start a series',
      editTitle: 'Edit {name}',
      editSubtitle: "Changes apply to the next episodes. The ones already made keep theirs.",
      subtitle: "A new video on your topic, on the schedule you pick.",
      back: 'Your series',
      notFound: "This series isn't yours or no longer exists.",
      cancel: 'Cancel',
      previous: 'Back',
      next: 'Next: {step}',
      start: 'Start the series',
      starting: 'Starting…',
      save: 'Save changes',
      saving: 'Saving…',
      savedNote: 'Saved. The next episodes follow the new settings.',
      startedOne: "Your series is set up. Episode 1 is being made now and will be ready to watch in a few minutes.",
      startedMany: "Your series is set up. The first {n} episodes are being made now and will be ready to watch in a few minutes.",
      startedAt: "Your series is set up. Its first episode is made {when}.",
      startedLater: "Your series is set up.",
      steps: {
        idea: 'Idea',
        look: 'Look & sound',
        when: 'When',
      },
      topic: 'What is your series about?',
      topicPlaceholder: 'e.g. Legends from ancient Egypt, told for adults, one per episode',
      starterReplaced: 'Your own idea was replaced.',
      starterUndo: 'Back to my idea',
      topicHint: 'A sentence or two is enough. Every episode takes a new story, fact or angle on it.',
      niches: {
        title: 'Or start from a niche that works',
        hint: 'One tap sets the topic, format, look, music and narrator, and writes the first episodes. Change anything after.',
      },
      captions: {
        title: 'Captions',
        hint: 'How the narration looks on screen, the same in every episode.',
        off: 'No captions',
        more: "{n} more styles",
        custom: 'Your own style',
        customHint: 'The style you made on an episode. Pick another to replace it.',
      },
      music: {
        title: 'Music',
        hint: 'Under the narration, from our own library, safe to post anywhere.',
        auto: 'Matched to each episode',
        off: 'No music',
        listen: 'Listen',
        stop: 'Stop',
      },
      hear: {
        play: 'Hear an episode',
        stop: 'Stop',
        what: '{voice} · {music}',
        matched: 'music matched to each episode',
        noMusic: 'no music',
      },
      mock: {
        caption: 'Nobody knew why',
        countdown: 'Fastest animals on Earth',
        quiz: 'Which planet is the hottest?',
        quizA: 'Venus',
        quizB: 'Mercury',
        pov: 'You wake up in Rome, 79 AD',
        chat1: 'did you hear that?',
        chat2: 'hear what?',
        chat3: "someone's in the house",
      },
      quickStart: {
        button: "Start with these settings",
        hint: "The first episode is made at its time. Change anything later.",
        hintNow: "Episode 1 is made now, the rest on the schedule. Change anything later.",
        hintNowMany: "The first {n} episodes are made now, the rest on the schedule. Change anything later.",
      },
      titleCard: {
        title: 'Open each episode with its title',
        hint: '"{kicker}" over the episode\'s title for its first seconds, so every episode looks like the same show. Change or remove it on any episode.',
        episode: 'Ep. {n}',
      },
      seePreview: 'See your series',
      format: 'What an episode looks like',
      formatHints: {
        story: 'A narrated story over pictures',
        countdown: 'Five things, counted down to #1',
        quiz: 'Questions the viewer plays along with',
        chat: 'A story told as a text chat',
        pov: 'You are there, as it happens',
      },
      moreOptions: 'Name and notes',
      fewerOptions: 'Hide name and notes',
      name: 'Series name',
      namePlaceholder: "We'll name it from your topic",
      notes: 'Notes every episode follows',
      notesPlaceholder: 'Tone, audience, what to always and never do',
      noteIdeas: {
        kids: 'For kids aged 6 to 9',
        gentle: 'Never gory or frightening',
        funny: 'Light and funny',
        facts: 'Only real, checkable facts',
      },
      narratorHint: "Tap play to hear each one in your series' language.",
      listen: 'Listen to {name}',
      stop: 'Stop',
      ownVoiceLine: 'Your own voice, up to {minutes} min an episode',
      shapes: {
        '9x16': 'Vertical',
        '16x9': 'Wide',
        '1x1': 'Square',
        '4x5': 'Portrait',
      },
      perMonth: 'about {n} videos a month',
      time: 'At what time',
      timeHint: 'Each episode is drafted then, on your clock, and waits for you.',
      times: {
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        night: 'Night',
      },
      nowTitle: "Episodes to make right away",
      nowHint: "Ready to watch in a few minutes, one AI video each. The rest follow the schedule.",
      nowNone: "None",
      nowCount: "{n}",
      lengthLocked: 'Longer episodes come with a paid plan.',
      fit: {
        unlimited: 'Your plan has no limit on AI videos.',
        fits: 'About {n} AI videos a month. You have {left} left this period: enough.',
        short: 'About {n} AI videos a month, but you have {left} left this period: it pauses after {episodes} episodes and we email you.',
        none: 'You have no AI videos left this period: the series waits until they renew.',
        upgrade: 'See plans',
      },
      card: {
        now: 'Now',
        today: 'Today',
        tomorrow: 'Tomorrow',
        week: 'Your first week',
        newIdea: 'A new idea',
        moreThisWeek: "+{n} more this week, each with a new idea",
        promise: 'Nothing is posted: every episode waits for you.',
        fillsIn: 'This fills in as you choose. Show the first episodes to see them here.',
      },
      preview: {
        title: 'Your first episodes',
        hint: 'Written from your idea in a few seconds, before anything is made. Free, and you can change any of them.',
        write: 'Show me the first episodes',
        writing: 'Writing your first episodes…',
        rewrite: 'Rewrite',
        remove: 'Remove',
        edit: 'Edit',
        add: 'Add another',
        again: 'Your idea changed since these were written.',
        againButton: 'Write them again',
        failed: "Couldn't write them just now. Try again.",
        tooMany: "That's enough previews for today. The series still writes its episodes as it goes.",
        episode: 'Episode {n}',
        more: 'More',
        less: 'Less',
        save: 'Save',
        cancel: 'Cancel',
        titleLabel: 'Episode title',
        ideaLabel: 'What the episode is about',
        needTopic: 'Describe your series first (a sentence or two).',
      },
    },
    review: {
      hint: "Watch it, say how it was, then save it or post it.",
      watch: 'Watch episode {n}',
      exporting: 'Being exported: it plays here as soon as it is ready.',
      notExported: "This one isn't exported yet. Open it to watch it, change it and export it.",
      feel: 'How was it?',
      feelHint: 'The next ideas lean toward the episodes you like.',
      post: 'Post it',
      openEditor: 'Open in the editor',
      redo: 'Make this episode again',
      redoTitle: 'Make episode {n} again?',
      redoText: 'A new version takes its place, with the same number. This video and its file are replaced. It uses one of your plan\'s videos.',
      redoKeep: 'Keep this one',
      redoStarted: 'Episode {n} is being made again. It appears here when it is ready.',
      redoFailed: 'It could not be made again. Try again in a moment.',
      redoLimit: 'Your plan has no videos left this month.',
      upNext: 'Up next:',
      makeNext: 'Make it now',
      madeNext: 'Making it now. It shows on the series card, and the email says when it is ready.',
      madeNextFailed: "Couldn't start it. Try from the series card.",
      previous: 'Previous',
      next: 'Next',
      of: '{i} of {total}',
    },
    note: {
      setsLook: "Captions and music you choose here become the series' look: the next episodes start with them.",
      wearsLook: "It starts in the series' look. Change the captions or music here and the next episodes follow.",
      episode: 'Episode {n} of {name}',
      seeSeries: 'See the series',
    },
    makeItOne: 'Make it a series: a new video like this on a schedule',
    hero: {
      new: 'New series',
      start: 'Start your first series',
    },
    creator: {
      heroHint: 'This series is built around one hero. Create them here and they look the same in every episode.',
      steps: 'Steps',
      untitled: 'Your series',
      summaryLabel: 'Summary',
    },
    card: {
      posted: '{n} posted',
      cost: 'Each episode uses 1 of your {n} AI videos left',
      waiting: '{n} to review',
      makeOne: 'Make an episode now',
      review: "Review episodes",
      making: 'Writing the idea…',
      more: 'More',
      makeThree: 'Make 3 episodes now',
      edit: 'Edit series',
    },
    made: {
      started: "Making {n} now. Each is ready to watch in a few minutes.",
      stopped: {
        out_of_videos: 'Your plan has no AI videos left this period.',
        out_of_minutes: 'Your plan has no minutes left this period.',
        longer_than_plan: 'Your plan makes 30-second videos: shorten the episodes or upgrade.',
        already_making: 'Episodes are already being started. Give it a moment.',
        other: "Couldn't start an episode. Try again.",
      },
      upgrade: 'See plans',
    },
    starters: {
      title: 'Start from an idea',
      more: 'Ideas for your next series',
      hint: 'One tap fills it in. Change anything.',
      withCast: 'With a hero',
      legends: { title: 'Legends & myths', topic: 'Legends and myths from around the world, told for adults. One legend per episode, true to how it is really told.' },
      hero: { title: 'Bedtime adventures', topic: 'Gentle bedtime adventures for children aged 4 to 8, starring the same young hero. Each episode a new place and a small lesson about kindness or courage.' },
      top5: { title: 'Top 5 facts', topic: 'Top 5 countdowns of surprising, true facts about science and nature. Each episode one subject, counted down to the most surprising.' },
      pov: { title: 'History POV', topic: 'You are there: one day in history seen through the eyes of an ordinary person, in the second person. True to the period, one era per episode.' },
      quiz: { title: 'Quiz time', topic: 'Quizzes the viewer plays along with: general knowledge questions that get harder, with the answer after a short pause.' },
      chat: { title: 'Text stories', topic: 'Short stories told through a text conversation between two friends, with a twist at the end. Everyday situations, never real people.' },
      scary: { title: 'Scary stories', topic: 'Short scary stories to tell at night: haunted houses, strange neighbours, things seen on empty roads. Original stories, one per episode, with a twist at the end.' },
      facts: { title: 'Did you know?', topic: 'One surprising, true fact per episode about history, nature or everyday things, explained so it sticks. Only real, checkable facts.' },
      fables: { title: 'Little lessons', topic: 'Short fables for children aged 4 to 8: an animal learns something about sharing, patience or honesty. Gentle and funny, with a clear lesson at the end.' },
      stoic: { title: 'Stoic wisdom', topic: 'One idea from the Stoics (Marcus Aurelius, Seneca, Epictetus) per episode, told through a moment from their lives and what it means for a day like today.' },
      love: { title: 'Love stories', topic: 'Short, tender love stories: first meetings, long distances, second chances. Everyday people, never real ones, each with a moment that stays with you.' },
      whatif: { title: 'What if…?', topic: 'What would happen if the Moon disappeared, we stopped sleeping, or the internet went off for a year? One question per episode, answered with real science, step by step.' },
    },
    ideaFirst: {
      title: 'Episode {n}: the idea',
      remakeTitle: 'Episode {n} again: its idea',
      newIdea: 'Write a new idea',
      hint: 'This is what the episode will be made from. Change anything you like, then make it. It uses one of your plan\'s videos.',
      writing: 'Writing the idea…',
      draftFailed: 'The idea could not be written. Close this and try again.',
      make: 'Make episode {n}',
      remake: 'Make episode {n} again',
      failed: 'It could not be made. Try again in a moment.',
    },
    upNext: {
      none: "The next idea is written when the episode is due. Add your own to choose it.",
      noneWhen: "Next episode {when}: its idea is written then.",
      all: 'All ideas ({n})',
      title: 'Up next',
      hint: 'The next ideas, before anything is made. Change them, swap them, or add your own.',
      error: "Couldn't load the next ideas. Refresh to try again.",
      writing: 'Writing the next ideas…',
      yours: 'Your idea',
      first: 'Next',
      untitled: 'Untitled idea',
      make: 'Make now',
      edit: 'Edit this idea',
      swap: 'Swap for another idea',
      earlier: 'Move earlier',
      remove: 'Remove this idea',
      add: 'Add your own idea',
      save: 'Save',
      cancel: 'Cancel',
      titleLabel: 'Title',
      titlePlaceholder: 'A working title',
      ideaLabel: 'The idea',
      ideaPlaceholder: 'What this episode is about, and its angle',
    },
    continuity: {
      label: 'Episodes',
      standalone: 'Each one stands alone',
      standaloneHint: 'A new story, fact or angle every time.',
      continuing: 'One continuing story',
      continuingHint: 'Each episode picks up where the last one ended.',
    },
    notes: {
      label: 'Series notes (optional)',
      hint: 'Every episode follows them: tone, audience, what to always and never do.',
      placeholder: 'For kids aged 6 to 9. Warm and funny, never scary. Always end with a kind act.',
    },
    feedback: {
      up: 'More like this',
      down: 'Less like this',
    },
    nudgeTitle: 'Making a series?',
    nudgeBody: 'This looks like one part of several. A series writes and makes the next episodes for you, on a schedule you set, in this look and voice; you review each one before posting.',
  },
  fairBilling: {
    eyebrow: 'Fair billing',
    title: 'You pay for what you get. Nothing else.',
    failTitle: 'Failures are on us',
    failBody: 'A video, clip or render that fails costs nothing, and redoing an image or a voice inside a video never costs another video.',
    rollTitle: 'Unused minutes roll over',
    rollBody: 'Minutes and AI videos you don\'t use this month carry into the next, up to a month\'s worth.',
    keepTitle: 'Your projects stay yours',
    keepBody: 'Cancel or downgrade and your projects and exports stay in your account for at least 90 days.',
    note: 'Rollover is on Pro. Yearly plans get their minutes and videos every month.',
  },
  pricing: {
    badge: 'Used by 10,000+ creators',
    title: 'Simple, Transparent Pricing',
    subtitle: "Choose the plan that's right for you. Start free, upgrade anytime.",
    monthly: 'Monthly',
    annual: 'Annual',
    cancelAnytime: 'Cancel anytime',
    // Egypt's price is charged in dollars (Stripe cannot bill pounds): the pounds beside it are an estimate
    localApprox: '≈ {amount} EGP',
    billedInDollars: 'Billed in US dollars. Your bank converts it to pounds and may add a small fee.',
    securePayments: 'Secure payments via Stripe',
    noCard: 'No credit card required for free plan',
    grandfatheredTitle: "You're on a Grandfathered Plan",
    grandfatheredBody: 'This plan is no longer available to new customers. You can keep your current pricing and limits, or switch to our new Pro plan.',
    manage: 'Manage your subscription',
    currentPlan: 'Your current plan',
    currentPlanButton: 'Current Plan',
    freeName: 'Free',
    freeDescription: "A free hour of AI clipping a month, with captions and reframing. No card. AI videos come with Pro or a pack.",
    forever: '/forever',
    freeHours: '{n} hour of video processing per month',
    clippingTools: 'AI clipping, Auto Captioning, Reframing',
    repromptOne: '{n} reprompting attempt per video',
    editorRendering: 'Full editor rendering',
    freeAgent: "AI videos: {n} Pro videos for {price}, paid once",
    proSeason: '+{n} bonus AI videos this October',
    promoTitle: 'October offer: {n} bonus AI videos with Pro',
    promoText: 'Subscribe this month and {n} extra AI videos are added to your account right away, on top of your plan. They never expire.',
    promoRibbon: 'October offer · +{n} bonus AI videos',
    imageRegens: '{n} image regenerations per video',
    noImageEdits: 'No image edits',
    noAnimations: 'No image-to-video animations',
    noVoiceRegens: 'No voice regenerations',
    proOnly: 'Pro only',
    noWatermarks: 'No watermarks on exports',
    editorAccess: 'Access to video editor',
    prioritySupport: 'Priority email support',
    freeCta: 'Get Started Free',
    proName: 'Pro',
    packageSummary: '{hours}h + {videos} videos',
    scale: 'Scale as you grow',
    proHintSubscriber: 'Drag the slider to add more hours and AI videos, or scale down.',
    proHint: "Pick how much you need. Every bundle adds hours, AI videos and more tries; change it any time.",
    hoursUnit: 'hours',
    hoursSuffix: 'of video processing per month',
    repromptMany: '{n} reprompting attempts',
    perVideo: 'per video',
    agentVideosUnit: 'AI Agent videos',
    perMonth: 'per month',
    imageRegensBold: '{n} image regenerations',
    imageEditsBold: '{n} image edits',
    animationsBold: '{n} image-to-video animations',
    voiceRegensBold: '{n} voice regenerations',
    deltaUp: '+{hours}h processing • +{videos} AI videos',
    deltaDown: '-{hours}h processing • -{videos} AI videos',
    openingPortal: 'Opening Portal...',
    upgradePlan: 'Upgrade Plan',
    downgradePlan: 'Downgrade Plan',
    processing: 'Processing...',
    proCta: "Start Pro",
    proCtaMany: "Start Pro: {videos} AI videos, {amount} today",
    proCtaYear: "Start Pro: {amount} today, paid yearly",
    proFootnote: 'Cancel anytime. Scale up or down as you grow.',
    authTitle: 'Authentication Required',
    authBody: 'Please sign up to subscribe to a plan.',
    checkoutError: 'Checkout Error',
    checkoutErrorBody: 'Failed to initiate checkout. Please try again.',
    portalError: 'Portal Error',
    portalErrorBody: 'Failed to open subscription management. Please try again.',
    slider: {
      perYear: 'yr',
      perMonth: 'mo',
      perMonthEq: "{price} a month, paid yearly",
      saveYear: "Save {amount} a year",
      processing: '{n}h processing',
      aiVideos: '{n} AI videos',
    },
    picker: {
      howMany: 'How many AI videos a month?',
      unit: 'videos',
      preset: '{n} videos a month',
      fewer: 'Fewer videos',
      more: 'More videos',
      firstMonth: 'your first month',
      then: 'then {price} a month',
    },
    annualSave: "Save {n}%",
    rollOver: "Unused minutes roll over",
    howMuch: "How much do you need?",
    moreThan: "Need more than {hours} hours a month?",
    moreThanLink: "Email us",
    compare: {
      title: "Compare plans",
      subtitle: "What you get on Free and on Pro",
      features: "What you get",
      free: "Free",
      pro: "Pro",
      freePrice: "{price} forever",
      proPrice: "from {price} a month",
      perVideo: "{n} per video",
      perVideoRange: "{a}–{b} per video",
      hours: "{n} h",
      hoursRange: "{a}–{b} h",
      range: "{a}–{b}",
      videosOnce: "Pack: {n} for {price}",
      rows: {
        hours: "Video processing a month",
        hoursHint: "AI Clipping, Auto Caption, Reframe, editor exports",
        videos: "AI videos a month",
        reprompts: "New clip searches",
        redraws: "Image redraws",
        edits: "Image edits",
        animations: "Animated pictures",
        voice: "Voice redos",
        watermark: "Watermark",
        support: "Support",
      },
      watermarkFree: "Small Clip-Short mark",
      supportFree: "Email",
      supportPro: "Priority email",
      yes: "Included",
      no: "Not included",
      bothTitle: "On both plans",
      both: "AI Clipping, Auto Caption, Reframe, the full editor, Series and Characters, 1080p exports, downloads and cloud storage.",
      bundleNote: "Pro runs from one bundle to ten. Every bundle adds {hours} hours, {videos} AI videos and its share of tries.",
    },
    // Every way to pay in one dated table (components/PricingPage/AtAGlance.jsx)
    glance: {
      eyebrow: "At a glance",
      title: "Every way to pay, in one table",
      plan: "Plan",
      includes: "What you get",
      free: "Free",
      freePrice: "{price} a month",
      freeBody: "{minutes} minutes a month of AI Clipping, Auto Caption and Reframe, with a small watermark, and the full editor. Sign-up needs no card. No AI Agent videos.",
      pack: "Pack of {n} Pro videos",
      once: "{price}, paid once",
      packBody: "{n} AI Agent videos as Pro makes them, with no watermark. No subscription.",
      clipPack: "Clip pack",
      clipPackBody: "{minutes} minutes of AI Clipping, every clip of those videos exported without the watermark, and {remixes} remixes. No subscription.",
      pro: "Pro, monthly",
      proPrice: "{price} a month per bundle",
      proBody: "Each bundle gives {hours} hours of video processing and {videos} AI Agent videos a month, with no watermark. Take 1 to {max} bundles and cancel anytime.",
      yearly: "Pro, yearly",
      yearlyPrice: "{price} a year per bundle",
      yearlyBody: "{perMonth} a month. The {hours} hours and {videos} AI videos of each bundle arrive every month of the year.",
      fair: "Fair billing",
      fairBody: "A video, clip or render that fails costs nothing. On Pro, unused minutes and AI videos carry into the next period, up to one period’s worth. Cancel or downgrade and your projects stay in your account for at least 90 days.",
    },
    faq: {
      title: "Questions about pricing",
      subtitle: "Billing, what counts, and what you can do with the videos.",
      more: "Still have a question?",
      contact: "Write to support@clip-short.com",
      items: [
        {
          q: "How does Pro pricing work?",
          a: "Pro comes in bundles. One bundle is {hours} hours of video processing and {videos} AI videos a month, for {monthly} a month or {yearly} a year ({yearlyPerMonth} a month, {saving} less than paying monthly). Drag the slider to take up to ten; the price and everything you get scale together, and you can change it any time from your account.",
        },
        {
          q: "What counts as processing time?",
          a: "The length of the video you hand a tool. A 60-minute video costs 60 minutes whether you take 5 clips or 20 from it: AI Clipping, Auto Caption and Reframe count the source video, and the editor counts the finished one. A job that fails costs nothing.",
        },
        {
          q: "What is an AI video?",
          a: "A finished video made from an idea you type: the script, pictures in the style you choose, a narrator, captions and music from our own library. You can redraw or edit any picture, animate it, redo the voice, and post the result as it is. A Series makes one on a schedule, and each episode counts as one AI video.",
        },
        {
          q: "Do unused minutes and videos roll over?",
          a: "On Pro, yes. What you don't use in a month carries into the next, up to one month's worth. Yearly plans get their minutes and videos every month and roll over the same way.",
        },
        {
          q: "Is there a watermark?",
          a: "Free exports carry a small Clip-Short mark. Pro exports are clean, and they are yours to post and use for clients; whether a video earns money is up to each platform.",
        },
        {
          q: "Can I change or cancel my plan?",
          a: "Any time. Adding bundles takes effect at once and you pay the difference for the rest of the period; removing bundles takes effect at the next renewal; cancelling keeps Pro until the end of what you paid for. Your projects stay in your account either way.",
        },
        {
          q: "What if Pro isn't for me?",
          a: "Write to support@clip-short.com within 14 days of your first payment and we refund it in full, no questions asked.",
        },
        {
          q: "How do I pay, and in which currency?",
          a: "By card, on Stripe's checkout; your card number never reaches us. In Brazil the pack of Pro videos can also be paid with Pix, and the checkout shows the other methods Stripe accepts in your country. You are charged in your own currency where Stripe can bill it (euros in Europe, pesos in Mexico, reais in Brazil, and so on), and in US dollars elsewhere, which your bank converts.",
        },
      ],
    },
  },

  suggest: {
    text: 'This site is also in English.',
    link: 'View in English',
    close: 'Close',
  },

  season: {
    label: 'Halloween',
    message: 'Halloween is coming: make a scary story video in minutes.',
    cta: 'Get ideas',
    paidOffer: 'October offer: subscribe this month and get {videos} extra AI videos right away, on top of your plan.',
    paidOfferShort: 'Oct: +{videos} AI videos with Pro',
    paidCta: 'See Pro',
    close: 'Close',
  },

  videoFeedback: {
    title: 'How did this video turn out?',
    body: 'Tell us what you think, and why. We read every answer and use it to make the next videos better.',
    good: 'Good',
    bad: 'Not good',
    thanks: 'Thanks! We read every answer.',
    askGood: 'What did you like most?',
    askBad: 'What went wrong? Tell us so we can fix it.',
    send: 'Send',
    change: 'Change',
    later: 'Not now',
    failed: 'That did not go through. Try again.',
  },
  referral: {
    kicker: "A Pro video for you",
    offer: "Share this video. When a friend you bring buys a pack or Pro, you get a Pro video.",
    action: 'Share and earn a video',
    progress: '{joined} friends joined · {earned} of {cap} videos earned this month',
    wallAction: "Share a video, earn a Pro one",
    exportFirst: "Export your video first. Then share it: when a friend you bring buys a pack or Pro, you get a Pro video.",
  },
  share: {
    button: 'Share',
    title: 'Share your video',
    body: 'Anyone with the link can watch it and make one like it. You can stop sharing whenever you want.',
    whatsapp: 'Share on WhatsApp',
    facebook: 'Share on Facebook',
    copy: 'Copy link',
    copied: 'Link copied',
    stop: 'Stop sharing',
    stopped: 'Sharing is off: the link no longer works.',
    error: "Couldn't change sharing. Please try again.",
    message: "Look at the video I made with AI. Make yours here 👉",
    linkTitle: 'Public link',
    dialogTitle: 'Share this video',
  },
  // The public gallery switch (components/share/GallerySwitch.jsx, api routes/gallery.py)
  gallery: {
    title: "Public gallery",
    body: "List this video in Clip-Short’s public gallery, where anyone can find and watch it. Turn it off at any time and its page is gone.",
    remove: "Take it out",
    switchLabel: "Show in the public gallery",
    pending: "Waiting for review. It shows in the gallery once approved.",
    public: "In the gallery",
    view: "See its page",
    rejected: "Not approved: {reason}",
    rejectedNoReason: "Not approved for the gallery.",
    error: "Could not change it. Try again.",
    captionLabel: "Your caption",
    captionHelp: "Optional: a few words for your gallery post, shown under the video. It shows once we have reviewed it, and you can change or remove it at any time. No links.",
    captionPlaceholder: "Say something about this video…",
    captionSave: "Save caption",
    captionRemove: "Remove caption",
    captionWaiting: "Caption waiting for review",
    captionShown: "Caption shown on the post",
    refused: {
      caption_has_a_link: "No links, web addresses or emails in the caption.",
      caption_too_long: "Up to 500 characters.",
      not_exported: "Export the video first.",
      not_finished: "The video is not finished yet.",
      gallery_rejected: "This video was not approved. Change it and export it again to ask once more.",
    },
  },
  sharedVideo: {
    clipMadeWith: "Clipped with Clip-Short",
    clipOwn: "Clip your own video",
    clipPitch: "Paste a YouTube link and get its best moments as vertical clips, framed and captioned, in minutes.",
    clipMessage: "Watch this clip 👉",
    bothGet: "Write your own idea and get a video like this one: narrated, illustrated and captioned.",
    madeWith: 'Made with Clip-Short',
    idea: 'The idea:',
    makeOne: 'Make one like this',
    createFree: "Create your video",
    pitch: 'This video came from a single idea. Write yours and the AI Agent makes the script, the images, the narration and the captions.',
    copied: 'Link copied',
    notFoundTitle: 'This video is not available',
    notFoundText: 'Its owner may have stopped sharing it. You can make your own in minutes.',
    loading: 'Loading...',
    whatsapp: 'WhatsApp',
    message: 'Look at this video made with AI 👉',
  },

  auth: {
    checkStalled: { title: 'Sign-up is stuck on a security check', body: "The check that keeps bots out didn't load, so Continue can't go on. Use Continue with Google above, or reload the page. A VPN or an ad blocker can stop it.", google: 'Continue with Google', reload: 'Reload the page' },
    // The name carries a non-breaking hyphen (U+2011), as in es and pt, so a
    // narrow screen never breaks the heading between "Clip-" and "Short"
    loginTitle: 'Sign in to Clip‑Short',
    loginSubtitle: 'Access your projects and continue editing.',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    signupTitle: 'Create your Clip‑Short account',
    unavailableTitle: 'Clip‑Short is not available in your country',
    unavailableBody: 'You cannot sign up or sign in from here at the moment.',
    signupSubtitle: 'Get started in a few seconds.',
    haveAccount: 'Already have an account?',
    signIn: 'Sign in',
    loginError: 'Authentication Error',
    signupError: 'Signup Error',
    authFailed: 'Authentication failed. Please try again.',
    serverError: 'Server error occurred. Please try again later.',
    loadingAccount: 'Loading your account',
    accountErrorTitle: "We couldn't load your account",
    accountErrorText: "You're signed in, but our server didn't answer. It's usually back in a few seconds.",
    tryAgain: 'Try again',
    signOut: 'Sign out',
    slowText: 'Sign-in is taking longer than usual. A slow connection can do this.',
    reload: 'Reload the page',
    ideaTitle: 'Your video is one step away',
    ideaSaved: 'Your idea is saved',
    ideaNext: "Create your account and your idea is waiting on the next page, ready to make.",
    // Under the sign-up form. The free plan's numbers (config/pricing.js), held equal by a test
    signupValue: "1 free hour of AI clipping a month, with captions and reframing. No card.",
    signupSeoTitle: 'Create your free Clip-Short account',
    signupSeoDescription: "A free hour of AI clipping a month, with captions and reframing. No card. Sign up with Google or email.",
    loginSeoTitle: 'Sign in to Clip-Short',
    loginSeoDescription: 'Your projects, clips and AI videos. Sign in with Google or email.',
  },

  showcase: {
    sourceVideo: 'Source Video',
    aiAnalysis: 'AI Analysis',
    analyzeVideo: 'Analyze Video',
    clipsReady: 'Viral clips ready for every platform',
    tagVoice: 'Voice',
    tagSentiment: 'Sentiment',
    tagMotion: 'Motion',
    feedFollowing: 'Following',
    feedForYou: 'For You',
  },
  // The free video's worst picture redrawn by Pro (components/AIAgent/ProPreview.jsx)
  proPreview: {
    eyebrow: "Pro",
    title: "Your video, in Pro quality",
    body: "We drew one of your pictures again with our best model. Drag to compare.",
    // the default since 2026-10-13: one picture drawn again by rule, no defect named
    titleShowcase: "With Pro, every picture looks like this",
    bodyShowcase: "We drew one of your pictures again with our best model. Drag to compare. Pro makes the whole video at this quality.",
    proShowcase: "Pro: much higher quality, with far fewer mistakes",
    ownVoice: "Narrate in your own voice, or change the voice any time",
    titleGallery: "Bring your characters to life with Pro",
    bodyGallery: "Every picture drawn by our best model, and any picture you choose turned into a moving clip.",
    galleryNote: "Made with Pro: one character in three scenes, then animated",
    galleryAlt: "A character drawn and animated with Pro",
    chipGallery: "See what Pro makes",
    animatedBadge: "Animated",
    whatProGallery: "What Pro gives you",
    allPicturesGallery: "Every picture of your videos drawn by our best model",
    free: "Free",
    pro: "Pro",
    problemFree: "Free: {what}",
    proDrawn: "Pro: drawn again with our best model",
    proFixed: "Pro: drawn right",
    proBetter: "Pro: sharper and more lifelike",
    allPictures: "All {n} pictures of this video at this quality",
    allPicturesNoCount: "Every picture of your video at this quality",
    later: "Not now",
    compare: "Compare the free picture and the Pro picture",
    chip: "See one of your pictures drawn by Pro",
    altFree: "Your picture, drawn on the free plan",
    altPro: "The same picture, drawn by Pro",
    kindText: "Garbled text",
    kindExtra: "A character too many",
    kindWrong: "The wrong character",
    kindMissing: "A character is missing",
    kindAnatomy: "A hand or a face looks wrong",
    kindQuality: "Soft and short on detail",
    whatPro: "What Pro does for this video",
    cleanAndLong: "No watermark, and videos up to 10 minutes",
    firstMonth: "your first month",
    off50: "−50%",
    thenMonthly: "then {price} a month · cancel anytime",
    aMonth: "a month",
    cancelAnytime: "Cancel anytime",
  },
  checkoutWaiting: {
    label: 'A checkout you left',
    titlePro: 'Your Pro upgrade is still waiting',
    titlePack: 'Your 3 AI videos are still waiting',
    textPro: '{price} today. Pick up where you left off.',
    textPack: '{price}, no subscription. Pick up where you left off.',
    continue: 'Continue',
    question: 'What stopped you?',
    answers: {
      too_expensive: 'Too expensive',
      no_subscription: 'I don\'t want a subscription',
      payment_problem: 'A payment problem',
      just_looking: 'Just looking',
    },
    thanks: 'Thanks, that helps us.',
    close: 'Close',
    packAddedTitle: "{n} Pro videos added",
    packAddedText: "They're in your account: up to 3 minutes each, with no watermark. Use them any time.",
  },
  // A new account's first video, sold at Generate (components/upgrade/FirstVideoOffer.jsx)
  firstVideo: {
    title: "Your video is ready to make",
    proBadge: "Best value",
    proName: "Pro",
    perMonth: "a month",
    proVideos: "{n} AI videos every month",
    proClipping: "{n} hours of AI clipping a month",
    noWatermark: "No watermark",
    cancelAnytime: "Cancel anytime",
    proCta: "Go Pro and make my video",
    packBadge: "No subscription",
    packName: "{n} Pro videos",
    once: "paid once",
    packLength: "Up to {n} minutes each",
    noSubscription: "Nothing renews, nothing to cancel",
    packCta: "Buy for {price} and make my video",
    startsAfter: "Your video starts by itself as soon as you have paid.",
    yourIdea: "Your idea",
    showcaseTitle: "Made with Pro",
    showcaseNote: "Examples from other ideas",
    showcaseAnimated: "Animated",
    showcase_workshop: "In the workshop",
    showcase_balloon: "Up in a balloon",
    showcase_stars: "Under the stars",
    pickAnother: "Tap another to watch it",
    sound: "Sound",
    soundOn: "Sound on",
    playExample: "Play {name}",
    playWithSound: "Play {name} with sound",
    muteExample: "Mute {name}",
    perVideo: "≈ {price} a video",
    secure: "Secure payment by Stripe",
    changeIdea: "Change my idea",
    afterProLeft: "Prefer no subscription? {n} Pro videos for {pack}, paid once",
    freeTools: "Not now: make free clips from a video",
    starting: "Payment received. Your video is starting…",
    startingSlow: "Your payment is still being confirmed. Try again in a minute.",
  },
  // The Remix offer: a remix asked for with no video left (components/Remix/RemixOffer.jsx)
  remixOffer: {
    title: "Your remix is one step away",
    starts: "Choose a plan and your remix starts by itself. Nothing to choose again.",
    yours: "Your remix",
    showcaseNote: "Videos made with Pro, with no watermark. Tap one to play it.",
    showcaseNoteRemix: "Remixes made with Remix, from public-domain clips. Tap one to play it.",
    proRemixes: "{n} AI videos or remixes a month",
    proCta: "Go Pro and make my remix",
    back: "Back to my remix",
    starting: "Payment received. Starting your remix…",
    slow: "Your payment is still on its way. Your remix starts as soon as it arrives.",
    failed: "Your remix didn’t start: {reason}",
  },
  // The tools' watermark offer (components/upgrade/WatermarkOffer.jsx, RemoveWatermarkButton.jsx)
  watermarkOffer: {
    button: "Remove watermark",
    pro: "PRO",
    title: "Export without the watermark",
    body: "With Pro, every clip, captioned video and reframe you export is clean. Go Pro, then export again.",
    markGone: "Our mark comes off everything you export",
    showcaseNote: "Pro also makes whole videos like these. Tap one to watch it",
    monthlyBadge: "Most popular",
    monthlyName: "Pro, monthly",
    clean: "No watermark on anything you export",
    hours: "{n} hours of clipping, captions and reframing a month",
    videos: "{n} AI videos a month, like these",
    monthlyCta: "Go Pro and remove it",
    yearlyBadge: "{n} months free",
    yearlyName: "Pro, yearly",
    perYear: "a year",
    yearlyMonthly: "≈ {price} a month, paid once a year",
    yearlyCta: "Pay yearly",
    keep: "Keep the watermark",
  },
  clipExports: {
    title: "Export this clip",
    body: "On the free plan, your clip has the Clip-Short watermark. Pro exports every clip without it, and Remix makes a clip into a new video like these.",
    lockedTitle: "You exported {n} free clips from this video",
    lockedBody: "Pro exports every clip of every video without the watermark, and Remix makes a clip into a new video like these.",
    freeName: "Free plan",
    freeCta: "Export with the watermark",
    freeNote: "With the Clip-Short watermark",
    left: "Free exports left for this video: {left} of {limit}",
    every: "Every clip of every video, no watermark",
    remix: "Remix: a clip made into a new video",
    showcaseNote: "Made with Remix, each from one clip. Tap one to watch it",
    madeWith: "Made with Remix",
    lockedHint: "Pro exports every clip",
    cta: "Go Pro, export every clip",
    packName: "Clip pack",
    packOnce: "Paid once, never expires",
    packMinutes: "{n} minutes of AI Clipping",
    packClean: "Every clip of those videos, no watermark",
    packRemixes: "{n} remixes",
    packCta: "Get the Clip pack",
    unlockTitle: "Unlock this video with your Clip pack",
    unlockNote: "Uses {n} of your {m} pack minutes. Every clip then exports without the watermark.",
    unlockCta: "Unlock this video",
    unlockShort: "Your Clip pack does not have this video's minutes left",
    again: "Export again without the watermark",
    unlocked: "Your Clip pack is ready. Every clip of this video exports without the watermark.",
    packLeft: "Clip pack: {m} min · {r} remixes left",
    notNow: "Not now",
  },
  upgrade: {
    subscriberBody: 'You’re on Pro and have used this month’s videos. Add a bundle to your plan and keep going today.',
    subscriberMinutesBody: 'You’re on Pro and out of processing minutes. Add a bundle to your plan and keep going today.',
    bundleName: 'One more bundle: {price} a month',
    addToPlan: 'Add to my plan',
    videosTitle: "You've used your AI videos for this month",
    freeVideosTitle: "No AI videos left",
    minutesTitle: 'You have run out of processing minutes',
    body: 'Go Pro and keep making them today.',
    bodyRenews: 'Your free plan renews on {date}. Go Pro and keep going today.',
    minutesBody: 'This video needs {needed} minutes and you have {left} left. Go Pro and keep going today.',
    planName: 'Pro — {price} a month',
    planVideos: '{n} AI videos a month',
    planHours: '{n} hours of video processing a month',
    cta: 'Go Pro for {price} a month',
    pack: "Just need a few? {n} Pro videos for {price}: up to 3 minutes, no watermark, no subscription",
    ctaLoading: 'Opening checkout…',
    secondary: 'See all plans',
    coupon: 'Half price for your first month',
    planNameIntro: 'Pro — {first} your first month, then {price} a month',
    ctaIntro: 'Go Pro for {first} your first month',
    thenPrice: 'Half price for your first month, then {price} a month. Cancel anytime.',
    firstMinutes: 'Or make clips from the first {n} minutes, free',
    // Everything else the free plan has not got opens the same offer (UpgradeOffer `reason`)
    watermarkTitle: 'Export your video with no watermark',
    watermarkBody: 'On Pro, every video and clip you export is clean. Go Pro, then export this one again.',
    animateTitle: 'Animate your pictures with Pro',
    animateBody: 'Still pictures become moving clips. Pro includes {n} animations per video.',
    editTitle: 'Edit pictures with AI on Pro',
    editBody: 'Describe the change and the picture is drawn again. Pro includes {n} AI edits per video.',
    generateTitle: 'Draw more pictures with Pro',
    generateBody: 'Pro includes {n} new pictures per video.',
    voiceTitle: 'Redo a narration with Pro',
    voiceBody: 'Change the words or the voice of any scene. Pro includes {n} voice redos per video.',
    qualityTitle: "Pictures drawn by our best model",
    qualityBody: "Pro draws every picture with our best model and exports with no watermark.",
    longerTitle: 'Make longer videos with Pro',
    longerBody: 'A pack video runs up to 3 minutes. On Pro, videos run up to 10 minutes.',
    sceneTitle: "Scenes are a Pro feature",
    sceneBody: "An animated scene with its own sound and voices, made from your idea. Go Pro and make one now.",
    sceneFree: "Make it as a narrated video instead",
    withoutCharacters: "Make the video without characters",
    seriesTitle: "Series are a Pro feature",
    seriesBody: "A new episode on your schedule, written ahead, every one waiting for you to review. Go Pro and start one.",
    charactersTitle: "Recurring characters are a Pro feature",
    charactersBody: "The same face in every scene and every video, drawn once from a description or a picture. Go Pro and make your cast.",
    subscriberFeatureBody: 'This video has used what your plan gives it. Every bundle you add gives each video more.',
    planNoWatermark: 'No watermark on your videos',
    planLonger: 'Videos up to 10 minutes',
    planAnimate: 'Animated pictures and AI edits',
    planSeason: 'Subscribe in October and get {n} extra AI videos',
  },
  // An AI Clipping project's clips: the gallery cards, and making a remix of one
  common: {
    close: 'Close',
  },

  // Shown when a run of requests gets no answer at all — a page that has
  // stopped being true should say so rather than let someone wait
  connection: {
    lost: "Can't reach Clip-Short right now — this page may be out of date. Your videos keep processing.",
    retrying: 'Trying again…',
  },

  clips: {
    nextSteps: { title: "Make your clip impossible to scroll past", text: "Remix builds a new commentary video around the clip: a cold open, the backstory researched with a source for each fact, name tags, graphics and a question to end on. Or dub it into another language.", close: 'Close' },
    show: 'Show',
    filters: { all: 'All', top: 'Top picks', exported: 'Exported' },
    sortLabel: 'Sort clips',
    sortBest: 'Best first',
    sortTimeline: 'Timeline order',
    emptyExported: 'Nothing exported yet. Exported clips show up here, ready to download.',
    empty: 'No clips here yet.',
    clipScore: 'Clip score',
    clipScoreTitle: 'Clip score {score} of 100',
    score: { excellent: 'Excellent', strong: 'Strong', good: 'Good', fair: 'Fair' },
    place: '{length} · {from}–{to} in the source',
    why: 'Why this clip',
    captionsBurned: 'Captions burned in',
    captionsNone: 'No captions',
    captionsNamed: "Captions: {name}",
    playLabel: 'Play clip: {title}',
    openLabel: 'Open clip: {title}',
    editLabel: 'Edit clip: {title}',
    download: 'Download',
    open: 'Open clip',
    edit: 'Edit clip',
    export: 'Export clip',
    exporting: 'Exporting…',
    project: {
      clippingTitle: 'Finding your clips',
      clippingDone: 'You can leave — clips appear here when they’re ready.',
      captionsTitle: 'Transcribing your video',
      captionsDone: 'You can leave — the transcript appears here when it’s ready.',
      reframeTitle: 'Reframing your video',
      reframeDone: 'You can leave — the reframed video appears here when it’s ready.',
      stepFetch: 'Fetching the video',
      stepMoments: 'Watching for the best moments',
      stepFraming: 'Framing and captioning each clip',
      stepListening: 'Listening to every word',
      stepSaving: 'Saving the transcript',
      stepTracking: 'Tracking the subject and reframing every shot',
      stepUploading: 'Uploading the result',
      wentWrong: 'Something went wrong. Please try again.',
      usually: 'Usually takes a few minutes.',
      lookingFor: 'Looking for:',
      didntFinish: 'Didn’t finish',
      noMomentsTitle: 'The AI couldn’t find enough clear moments in this video.',
      noMomentsHint: 'Try a broader request, or ask for fewer clips.',
      noSoundTitle: 'This video has no sound.',
      noSoundHint: 'Captions come from what’s said in it. Try a video where someone talks.',
      fetchTitle: 'We couldn’t fetch this video.',
      fetchHint: 'It may be private, age-restricted or removed. Check the link, or upload the file instead.',
      downloadSlowTitle: "The download didn’t finish in time.",
      downloadSlowHint: "A very long video (a few hours, like a stream recording) can take longer than we allow, even when you clip only part of it. Upload the file, or a shorter video.",
      ytUnavailableTitle: "This video isn’t on YouTube any more.",
      ytPrivateTitle: "This video is private on YouTube.",
      ytAgeTitle: "YouTube keeps this video behind an age check.",
      ytMembersTitle: "This video is for the channel’s members only.",
      ytRegionTitle: "YouTube doesn’t show this video where we fetch it from.",
      ytNotYetTitle: "This video hasn’t started on YouTube yet.",
      ytHint: "Trying again won’t change that. Pick another video, or upload the file if you have it.",
      ytNotYetHint: "Try again once it has aired, or upload the file if you have it.",
      aiTitle: 'The AI service didn’t answer in time.',
      aiHint: 'Nothing is wrong with your video — try again in a moment.',
      genericTitle: 'Something went wrong while processing this video.',
      genericHint: 'Try again — if it keeps failing, the details below help us look into it.',
      retryLabel: 'What should the AI look for this time?',
      askedFor: 'You asked for {n} last time',
      retrying: 'Retrying…',
      retryChanged: 'Try again with this request',
      retry: 'Try again',
      repromptTitle: 'Find new clips',
      repromptBody: 'The AI goes over the whole video again with your request in mind. New clips are added next to the ones you have.',
      repromptPlaceholder: 'e.g. The part about pricing, anything controversial, the story about the first customer…',
      have: 'You have {n} already',
      cancel: 'Cancel',
      starting: 'Starting…',
      findClips: 'Find clips',
      backAllClips: 'Back to all clips',
      exportFailed: 'Export didn’t start',
      reframeFailed: 'Couldn’t start reframing. Try again.',
      deleteThis: 'Delete this project',
      deleteConfirm: 'Delete Project',
      deleteBody: 'Are you sure you want to delete “{title}”? This will permanently remove all data associated with this project, including any extracted shorts. This action cannot be undone.',
      repromptPasses: '{left} of {limit} searches left on this video. This spends one.',
      repromptPassesNone: 'No searches left on this video on your plan.',
      repromptRefused: 'Your plan’s searches on this video are used up ({used} of {limit}).',
      repromptFailed: 'Couldn’t start the search. Try again.',
    },
    bar: {
      back: 'Back to projects',
      finding: 'Finding new clips…',
      findingN: 'Finding {n} new clips…',
      noClips: 'No clips yet',
      preparing: 'Preparing previews · {ready} of {total} ready',
      ready: 'All previews ready',
      source: '{length} source',
      clips: '{n} clips',
      clipsOne: '{n} clip',
      more: 'More actions',
      deleteProject: 'Delete project',
      runsLabel: 'Clips from',
      findNew: 'Find new clips…',
      findNewLocked: 'Find new clips',
      repromptLimit: 'Your {plan} plan’s searches on this video are used up ({used} of {limit}). Bigger plans have more.',
      runOriginal: 'Original',
      runAll: 'All',
      runPrompt: 'Prompt {n}',
    },
    status: {
      exporting: 'Exporting…',
      waiting: 'Waiting to export (2 at a time)',
      captioning: 'Adding captions…',
      exportFailed: 'Export failed',
      captionsFailed: 'Captions failed',
      exportedCaptions: 'Exported with captions',
      exported: 'Exported',
      queued: 'Queued for preview',
      preparing: 'Preparing preview…',
      ready: 'Ready',
      outdated: 'Preview outdated',
      previewFailed: 'Preview failed',
      noPreview: 'No preview yet',
    },
    remixes: {
      one: 'Remix of this clip',
      many: '{n} remixes of this clip',
      making: 'Making…',
      ready: 'Ready',
      failed: 'Failed',
    },
    remix: {
      dubSound: "{language} dub",
      action: 'Remix',
      tooltip: 'Make a new video around this clip: a title card, a narrated hook, comments while it plays and an ending',
      title: 'Remix this clip',
      lead: "A new video built around your clip, written from what is said in it.",
      untitled: 'Untitled clip',
      ownSound: 'plays with its own sound',
      format: 'Format',
      formats: {
        didYouKnow: {
          kicker: "Did you know?",
          headline: "Most people get this wrong",
          label: 'Did you know',
          description: 'A surprising hook the clip pays off.',
          example: '“Did you know most people get this completely wrong?”',
        },
        explainer: {
          kicker: "Explained",
          headline: "What this really means",
          label: 'Explainer',
          description: 'Context first, then it stops to explain.',
          example: '“Here’s what you need to know before you watch this.”',
        },
        hotTake: {
          kicker: "Hot take",
          headline: "Nobody is saying this",
          label: 'Hot take',
          description: 'Reacts to it as it plays, then gives a take.',
          example: '“This is the most honest answer I’ve heard in a while.”',
        },
        backstory: {
          kicker: "The backstory",
          headline: "How it all started",
          label: 'Backstory',
          description: 'The story that leads up to this moment.',
          example: '“It started with one question…”',
        },
        custom: {
          kicker: "Your idea",
          headline: "Your video, your way",
          label: 'Your own',
          description: 'Describe the video you want.',
        },
      },
      direction: 'Direction',
      describe: 'Describe your video',
      directionPlaceholder: 'Optional: anything to focus on, or a tone. e.g. “Keep it playful”, “Focus on the second half”.',
      describePlaceholder: 'e.g. Open with the question asked at the start, then explain why it matters to students.',
      commentary: 'How much the AI comments',
      levels: {
        light: { summary: "Light comments", label: 'Light', hint: 'Hook and ending, at most one comment in the clip.' },
        balanced: { summary: "Balanced comments", label: 'Balanced', hint: 'A comment about every 25 seconds of clip, up to 3.' },
        lots: { summary: "Lots of comments", label: 'Lots', hint: 'Reacts often: a comment about every 15 seconds, up to 6.' },
      },
      language: 'Narration language',
      voice: 'Voice',
      playVoice: 'Play a voice preview',
      stopVoice: 'Stop the voice preview',
      optional: "(optional)",
      narration: "Voice and language",
      costLeft: "Uses one AI video ({n} left). Ready in a minute or two.",
      costUnlimited: "Ready in a minute or two.",
      costPro: "Made with Pro or a video pack, with no watermark.",
      // The sketch of the remix beside the choices (RemixPreview.jsx)
      preview: {
        label: "Your remix",
        hook: "Hook",
        clip: "Clip",
        comment: "Comment",
        ending: "Ending",
        note: "A sketch: the AI writes the card and every comment from what is said in the clip.",
        voiceOver: "An AI voice opens it",
      },
      // Remix v2: angles instead of formats (components/Remix/AnglePicker.jsx)
      v2: {
        lead: "The AI reads your clip, finds the story behind it and builds a new video around it: a cold open, the backstory with shots from the video, graphics, its comments and an ending.",
        step: "Pick an angle",
        reading: "Reading your clip for angles…",
        failed: "No angles this time. Let the AI choose, or write your own.",
        aiChoice: "Let the AI choose",
        aiChoiceHint: "It picks the strongest story from the clip and what it finds about it.",
        own: "My own angle",
        ownPlaceholder: "What should the video be about? e.g. “The backstory of this moment”",
      },
      // Editing a v2 remix on its video page (components/Remix/RemixV2Editor.jsx)
      v2edit: {
        title: "Edit the remix",
        kicker: "Kicker",
        line: "Headline line {n}",
        stars: "Wrap the words to stress in *stars*: they show in the accent colour.",
        question: "End question",
        name: "Name",
        role: "Role",
        removeTag: "Remove this name tag",
        graphic: "Scene {n}: {kind}",
        removeGraphic: "Remove this graphic",
        shots: "Shots",
        shotsHint: "Each narrated part shows shots from the source video. Pick another one: it is saved at once.",
        part: "Part {n}",
        change: "Change",
        useShot: "Use this shot",
        cancel: "Cancel",
        shotsLoading: "Loading the shots…",
        shotsFailed: "Could not load the shots.",
        noShots: "This video has no other shots near the clip.",
        shotFailed: "Could not change the shot. Try again.",
        kinds: {
          display: "display",
          target: "target",
          gauge: "gauge",
          counter: "counter",
          pin: "map pin",
          document: "document",
          stamp: "stamp",
        },
        fields: {
          label: "Label",
          note: "Note",
          stamp: "Stamp",
          value: "Number",
          title: "Place",
          sub: "Line under it",
          header: "Header",
          line: "Line",
          cutNote: "Note when cut",
          keptText: "Stamp when kept",
          text: "Text",
        },
        quote: "Quote card, scene {n}",
        failed: "Couldn’t save. Try again.",
        saved: "Saved",
        save: "Save changes",
      },
      cancel: 'Cancel',
      submit: "Make the remix",
      submitPro: "Remix with Pro",
      starting: 'Starting…',
      off: 'Remix isn’t switched on for this server (REMIX_ENABLED).',
      failed: 'Couldn’t start the remix. Try again in a moment.',
    },
    // The clip workspace: the editor a clip opens in — its transcript,
    // stage, timeline, framing mode, settings and the clip strip
    workspace: {
      backToPreview: 'Back to the preview',
      // The three panes, and what stops an exported clip being edited
      transcript: 'Transcript',
      preview: 'Preview',
      settings: 'Clip settings',
      selectClip: 'Select a clip to preview it.',
      lockedExported: 'Exported clips keep their captions. Edit a copy to change them.',
      lockedExporting: 'Locked while the clip exports',
      prepareFailed: 'Couldn’t prepare the preview',
      captionsSaveFailed: 'Couldn’t save the captions',
      exportFailed: 'Export didn’t start',
      // The transcript on the left
      transcriptText: 'Transcript text',
      wordText: 'Word text',
      saving: 'Saving…',
      editsSaved: 'Your edits are saved · a dot puts a cut word back',
      editHint: 'Click any word to fix it · clear it to cut it',
      restoreOriginal: 'Restore original',
      loadingTranscript: 'Loading the transcript…',
      transcribing: 'Transcribing. The transcript arrives with the preview.',
      noTranscript: 'No transcript yet. Prepare the preview to transcribe this clip.',
      noSpeech: 'No speech in this clip.',
      editWord: 'Edit “{word}”',
      playFrom: 'Play from “{word}”',
      putBack: 'Put back “{word}”',
      // The toolbar above the stage
      aspectRatio: 'Aspect ratio',
      framing: 'Framing',
      automatic: 'Automatic',
      editedShotOne: 'Edited ({n} shot)',
      editedShots: 'Edited ({n} shots)',
      adjustFraming: 'Adjust framing',
      preparePreview: 'Prepare preview',
      refreshPreview: 'Refresh preview',
      refreshing: 'Refreshing…',
      refresh: 'Refresh',
      outdatedHint: 'This clip now starts or ends outside the range that was prepared, so the preview is behind. Exports render at full quality either way.',
      previewQuality: 'Preview quality',
      qualityHint: 'What the preview plays. Exports always render from the original at full resolution.',
      // The badge on the picture: what is being played
      badgeFast: '360p preview',
      badgeToHd: 'A quick 360p preview. Exports render at full resolution. Switch to HD',
      badgeToFast: 'Playing the original. Switch to the quick 360p preview',
      badgeStatic: 'A quick 360p preview. The export renders at full resolution',
      // The timeline under the stage
      play: 'Play',
      pause: 'Pause',
      mute: 'Mute',
      unmute: 'Unmute',
      playhead: 'Playhead',
      trimInHandle: 'Trim in',
      trimOutHandle: 'Trim out',
      framingPin: 'Framing pin',
      // Framing mode
      editedShot: 'edited shot',
      automaticShot: 'automatic shot',
      split: 'Split',
      splitHint: 'Split into two stacked crops from here',
      merge: 'Merge',
      mergeHint: 'Back to a single crop from here',
      pin: 'Pin',
      pinHint: 'Pin the framing here. Add another pin to pan between them',
      deletePin: 'Delete pin',
      deletePinHint: 'Remove the pin at the playhead. The framing around it stays',
      resetShot: 'Reset shot',
      resetShotHint: 'Automatic framing for this shot',
      resetAll: 'Reset all',
      resetAllHint: 'Automatic framing everywhere',
      cancel: 'Cancel',
      done: 'Done',
      saveDone: 'Save & done',
      framingHint: 'Drag the box to reframe this shot. Every other shot keeps its automatic framing.',
      // The settings on the right
      trim: 'Trim',
      long: '{length} long',
      trimIn: 'In',
      trimOut: 'Out',
      stepEarlier: '{label} 1 second earlier',
      stepLater: '{label} 1 second later',
      trimLocked: 'Exported clips keep their timing.',
      trimHint: 'Trim freely, or extend it: footage past the prepared part gets its framing and captions by itself while you keep editing.',
      captions: 'Captions',
      burnCaptions: 'Burn in captions',
      captionsExported: 'Captions are part of the exported file. Change them to render a new version.',
      changeCaptions: 'Change captions…',
      hintBurned: 'captions burned in',
      hintCaptions: '{name} captions',
      hintNoCaptions: 'no captions',
      openEditor: 'Open in the full editor',
      // The strip of clips along the bottom
      clipsTitle: 'Clips',
      drag: 'drag',
      scoreTitle: 'Clip score {score} of 100',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      editHintTouch: 'Tap any word to fix it · clear it to cut it',
      tools: 'Tools',
      sheetMore: 'Show more of the panel',
      sheetLess: 'Show less of the panel',
    },
    feed: { label: 'Clips, one per screen', soundOn: 'Turn sound on', soundOff: 'Turn sound off' },
  },

  // The tool pages (AI Clipping, Auto Caption, Reframe): the hero, the
  // composer, the setup once a video is in, and the projects below
  toolPage: {
    step1: 'Paste a link or drop a file',
    clipping: {
      headline: 'Paste a video. Post the best parts.',
      sub: 'The AI finds the moments that hold attention, frames the speaker for vertical, and burns in captions. You review, tweak and export.',
      step: 'Give it about 3 minutes',
      last: 'Review, tweak, export',
      eta: '3 minutes',
      setup: 'Set up your clips',
      note: 'About {eta} · The AI picks each clip’s length; trim anything afterwards.',
      cta: 'Get clips',
    },
    captions: {
      headline: 'Captions people actually read.',
      sub: 'The AI transcribes every word and burns in captions in the style you pick. Paste a link or drop a file.',
      step: 'Give it about 2 minutes',
      last: 'Preview, then download',
      eta: '2 minutes',
      setup: 'Ready to caption',
      setupSub: 'AI transcribes every word, timed to the voice. You pick the caption style on the result.',
      note: 'About {eta}',
      cta: 'Generate captions',
    },
    reframe: {
      headline: 'Any video, any aspect ratio.',
      sub: 'The AI reframes any video around its subject for vertical, square or wide. Paste a link or drop a file.',
      step: 'Give it about 2 minutes',
      last: 'Preview, then download',
      eta: '2 minutes',
      setup: 'Set up the reframe',
      note: 'About {eta} · The AI keeps the subject in frame, shot by shot.',
      cta: 'Reframe video',
    },
    segment: {
      title: 'What to process',
      whole: 'Whole video · {length}',
      choose: 'Choose a part',
      first: 'First {time}',
      from: 'From',
      to: 'To',
      startLabel: 'Start of the part',
      endLabel: 'End of the part',
      frameAt: 'Frame at {time}',
      watch: 'Watch from {time} on YouTube',
      wholeVideo: 'The whole video',
      toProcess: '{length} to process',
      uses: 'uses {used} of your {left} minutes left',
      minClipping: 'AI Clipping needs at least 5 minutes to find clips in.',
      minCaptions: 'Choose at least a few seconds.',
      maxReframe: 'Reframe takes up to 30 minutes at a time.',
      overMinutes: 'This is {length} minutes, and your plan has {left} left this month.',
      choosePart: ' Choose a part to process only some of it.',
      noteReframe: 'Reframe takes up to 30 minutes at a time, so we picked the first {time}. Drag the handles to choose another part.',
      noteMinutes: 'Your plan has {n} minutes left this month, so we picked the first {time}. Drag the handles to choose another part, or process the whole video on a bigger plan.',
    },
    clipSetup: {
      tooShort: 'This video is under 5 minutes — too short to cut clips from. Choose a longer video.',
      tooShortTry: 'But this video works with:',
      tooShortReframe: 'Make it vertical (9:16)',
      tooShortCaptions: 'Add captions',
      howMany: 'How many clips',
      suggest: 'We suggest {n} for {length} of video',
      suggested: ' (suggested)',
      minutes: '{n} min',
      hours: '{h} h {m} min',
      promptLabel: 'What should the AI look for?',
      optional: 'optional',
      promptPlaceholder: 'e.g. The pricing discussion, skip the intro, nothing before minute 5',
      ideasLabel: 'Prompt ideas',
      ideas: {
        funniest: 'Funniest moments',
        takeaways: 'Key takeaways',
        opinions: 'Strong opinions',
      },
      suggestPart: 'We suggest {n} for the {length} part',
    },
    composer: {
      upload: 'Upload',
      placeholder: 'Paste a YouTube, Twitch, Drive or X link…',
      urlLabel: 'Video URL',
      clearUrl: 'Clear URL',
      paste: 'Paste',
      drop: 'Drop your video to upload',
      dropHint: 'or drag & drop a video file here',
      showcaseTimed: 'Every word, timed to the voice',
      showcaseStyle: 'In the style you pick',
      captionStyle: 'Caption style',
      worksWith: 'Works with',
      clearFile: 'Clear selected file',
      reading: 'Reading the video…',
      readingSlow: 'This one is taking a few seconds. Still going.',
      yourVideo: 'Your video',
      ready: 'Ready',
      views: '{n} views',
    },
    ready: {
      notUploaded: 'Chosen · not uploaded yet',
      notThisOne: 'Not this one?',
      anotherFile: 'Choose another file',
      anotherLink: 'Paste another link',
      uploading: 'Uploading',
      uploadFile: 'Upload the file',
    },
    button: {
      starting: 'Starting…',
      uploading: 'Uploading…',
      chooseFile: 'Choose a file',
      uploadFirst: 'Upload the file first',
      invalidLink: 'Paste a valid link',
    },
    reframeSetup: {
      format: 'Output format',
      padding: 'When a shot can’t fill the frame',
      paddingNote: 'padding',
      blur: 'Blur',
      black: 'Black',
      tooLong: 'This video is {minutes} minutes long. Reframe takes up to 30 minutes at a time.',
      over30: 'over 30',
    },
    existing: {
      clips: 'You already have clips from this video{detail}.',
      captions: 'You already have captions from this video{detail}.',
      reframe: 'You already have a reframe from this video{detail}.',
      open: 'Open it →',
      clipCount: '{n} clips',
    },
    refusal: {
      firstMinutes: 'Make clips from the first {n} minutes',
      moreMinutes: 'Get more minutes',
    },
    projects: {
      title: 'Your projects',
      inProgress: 'In progress',
      loadError: 'Error loading projects',
      emptyTitle: 'No projects yet',
      emptyBody: 'Paste a link above — your first clips are a few minutes away.',
      emptyCaptionsTitle: 'No captions yet',
      emptyCaptionsBody: 'Paste a link above — your captioned video is a couple of minutes away.',
      emptyReframeTitle: 'No reframes yet',
      emptyReframeBody: 'Paste a link above — a reframe takes about as long as the video itself.',
      emptyCta: 'Add a new video',
      emptyDefault: 'Paste a link above — your first result is a few minutes away.',
    },
    limit: {
      title: 'Monthly limit reached',
      body: 'You’ve reached your monthly limit for projects. Upgrade to Pro for unlimited projects.',
      close: 'Close',
      pricing: 'View Pricing',
    },
    remove: {
      title: 'Delete Project?',
      body: 'Are you sure you want to delete “{title}”? This action cannot be undone.',
      thisProject: 'this project',
      stillCounts: "Deleting it does not give the video back: it still counts.",
      cancel: 'Cancel',
      deleting: 'Deleting…',
      confirm: 'Delete',
    },
    card: {
      processing: 'Processing…',
      failed: 'Failed',
      deleteLabel: 'Delete project',
      clips: '{n} clips',
      scenes: '{n} scenes',
      scene: "Scene",
      series: 'Series · {name}',
    },
  },

  // A scene clip: one short animated scene with its own sound (components/AIAgent/Scene*.jsx)
  studio: {
    label: "AI studio",
    seeAll: "See all",
    open: "Show what is in {name}",
    close: "Hide what is in {name}",
    videoTitle: "Create a video",
    videoSubtitle: "A narrator tells your idea over pictures and captions. From 1 to 10 minutes.",
    modes: {
      video: {
        name: "Video",
        what: "Narrated, 1 to 10 minutes",
        new: "New video",
      },
      scenes: {
        name: "Scenes",
        what: "One animated shot, {n} seconds",
        new: "New scene",
      },
      series: {
        name: "Series",
        what: "New videos on a schedule",
        new: "New series",
      },
      characters: {
        name: "Characters",
        what: "Your recurring cast",
        new: "New character",
      },
    },
    empty: {
      video: "Your videos will be listed here.",
      scenes: "Your scenes will be listed here.",
      series: "Your series will be listed here.",
      characters: "Your characters will be listed here.",
    },
  },
  sceneGuide: {
    sceneTitle: "This idea is one moment. Try a Scene",
    sceneBody: "Videos are told by a narrator over pictures. A single animated moment is made in Scenes.",
    storyTitle: "This idea is a whole story",
    storyBody: "A narrated video tells all of it. A Scene would show only one moment of it.",
    videoName: "Narrated video",
    videoFacts: [
      "A narrator tells it over pictures and captions",
      "1 to 10 minutes",
      "Best for a topic or a whole story",
    ],
    sceneName: "Scene",
    sceneFacts: [
      "One animated shot of {n} seconds",
      "The characters move and speak with their own voices",
      "Best for a single moment",
    ],
    recommended: "Recommended",
    goToScenes: "Go to Scenes with my idea",
    oneMoment: "Make just one moment of it in Scenes",
    makeVideo: "Make the narrated video",
    changeIdea: "Change my idea",
    cost: "Either one uses one of your videos.",
  },
  sceneStudio: {
    seoTitle: "Scenes: one animated shot with voices",
    title: "Create a scene",
    subtitle: "One animated shot of {n} seconds, with its own voices and sound. Ready in about a minute.",
    guide: "Say who is in it, what they do and what they say. One moment, not a whole story.",
    lookLabel: "Look",
    looks: { asDescribed: "As you describe it", animated3d: "3D animation", realistic: "Realistic", anime: "Anime", clay: "Clay", cartoon: "Cartoon" },
    shapeLabel: "Shape",
    vertical: "Vertical 9:16",
    horizontal: "Wide 16:9",
    languageLabel: "Voices speak",
    languageHint: "Only for lines you don't write yourself.",
    cost: "Uses 1 of your videos · {n} s · about a minute",
    costLeft: "Uses 1 of your {left} videos · {n} s · about a minute",
    creating: "Starting your scene…",
    needIdea: "First describe the moment: one sentence is enough.",
    exampleTitle: "This is a scene",
    exampleHint: "Made from this idea:",
    another: "See another",
    useIdea: "Use this idea",
    exampleIdeas: {
      cat: "An orange cat jumps onto the kitchen table and knocks over a cup of coffee. It looks at the camera and says: It wasn't me.",
      astronaut: "An astronaut opens the hatch of the ship and finds a tropical beach. He takes off his helmet and says: This is not Mars.",
      dino: "A small clay dinosaur tries to blow out the candles on its birthday cake and can't reach with its tiny arms. It says: Not again!",
    },
    mine: "Your scenes",
    mineEmpty: "Your scenes are kept here. Each one can be saved or shared.",
    making: "Being made…",
    failed: "Wasn't made",
    toVideoLead: "Want to tell a whole story, with a narrator?",
    toVideo: "Create a video",
    back: "Back to scenes",
  },
  sceneClip: {
    examples: [
      "An orange cat jumps onto the kitchen table and knocks over a cup of coffee. It looks at the camera and says: It wasn't me.",
      "An astronaut opens the hatch of the ship and finds a tropical beach. He takes off his helmet and says: This is not Mars.",
      "A small clay dinosaur tries to blow out the candles on its birthday cake and can't reach with its tiny arms. It says: Not again!",
    ],
    offer: {
      sceneTitle: "This sounds like a scene",
      sceneBody: "A narrated video would talk about it. A scene shows it: one shot of {n} seconds, with its own sound and voices.",
      storyTitle: "This is a whole story",
      storyBody: "A narrated video tells all of it. Or see how it opens: one shot of {n} seconds, animated, with its own sound and voices.",
      makeScene: "Make the {n}-second scene",
      firstScene: "Animate its first scene",
      makeVideo: "Make the narrated video",
      cost: "Either one uses one of your videos.",
      blocked: {
        real_person: "We can't show a real, named person",
        religious_figure: "We can't show a figure of worship",
        own_picture: "We can't use your own photo or a particular person's face",
        known_character: "We can't use characters from a film, a series, a game or a brand",
        adult: "We can't show nudity or sexual content",
      },
      blockedBody: "We can make a narrated video about it. Or describe a character of your own, and we'll animate it.",
      change: "Change my idea",
      noCast: "A scene doesn't use your saved characters yet.",
    },
    errors: {
      refused: "We couldn't make this scene the way you described it, and your video was not used. Try describing it another way.",
      create: "The scene couldn't be started, and your video was not used. Try again in a moment.",
    },
    page: {
      badge: "Scene",
      making: "Animating your scene",
      finishing: "Finishing your scene",
      wait: "About a minute. Stay here: it plays as soon as it is ready.",
      ready: "Your scene is ready",
      save: "Save the video to your device",
      send: "Send it to an app",
      sound: "Tap for sound",
      another: "Make another scene",
      removeWatermark: "Remove the watermark",
      idea: "Your idea",
      failedTitle: "This scene wasn't made",
      failed: {
        refused: "We couldn't make this scene the way you described it. Try describing it another way.",
        timeout: "It took too long, so we stopped it.",
        error: "Something went wrong while making it.",
        start: "Something went wrong before it started.",
      },
      givenBack: "Your video was given back: you can use it again.",
      tryAgain: "Try another idea",
      narrated: "Make it a narrated video",
    },
  },
  aiAgentPage: {
    // The owner's own pictures under the idea box (components/AIAgent/IdeaImages.jsx)
    images: { add: 'Add images', addMore: 'Add {{left}} more', hint: 'Up to 3: your product, logo, place, pet... The AI uses them in your video.', remove: 'Remove image', uploading: 'Uploading', failed: 'Could not upload this image', alt: 'Your image {{n}}' },
    seriesNudge: {
      title: "You've made {n} videos. Make the next ones a series?",
      text: "New videos on the same idea, on a schedule you pick, each waiting for you to watch. We start from your latest idea.",
      start: 'Make it a series',
      close: 'Not now',
    },
    mode: {
      label: 'What to make',
      video: 'One video',
      series: 'A series',
      seriesHint: "New videos on this idea, on a schedule you pick. Each one waits for you to watch before you post it.",
      plan: 'Plan my series',
      startFrom: 'Or start from:',
      scene: "A scene",
      sceneHint: "One shot of {n} seconds with its own sound and voices, made in about a minute. It uses one of your videos.",
      makeScene: "Make the scene",
      scenePlaceholder: "Describe one moment: who is in it, what they do, and what they say…",
    },
    seoTitle: 'AI Video Generator - Create Videos from Text',
    seoDescription: 'Generate professional videos from text prompts with AI. Create slide shows with images, narration, and visuals for social media in minutes.',
    title: 'AI Video Agent Studio',
    subtitle: 'Turn your ideas into engaging videos with realistic narration and cinematic visuals.',
    howItWorks: "See how it works",
    how: {
      title: "How a video is made",
      subtitle: "From one sentence to a narrated video, in about two minutes.",
      idea: "Create a video about the history of coffee",
      generate: "Generate",
      scene: "Scene {n}",
      lines: ["From the quiet highlands of ancient Ethiopia, a simple berry began a story that changed the world.", "A goat herder named Kaldi noticed his flock dancing after feasting on bright red cherries.", "Monks brewed the berries to stay awake for their night prayers."],
      pictures: "A picture for every moment of the script",
      voice: "Narrator",
      ready: "Ready to export",
      steps: {
        idea: { title: "Your idea", body: "One sentence is enough. Add a language, a style and a length if you like." },
        script: { title: "The script", body: "The AI writes the story scene by scene, with a hook to open it." },
        make: { title: "Pictures and voice", body: "Each scene gets its pictures, and a narrator reads the script." },
        video: { title: "Your video", body: "Captions, music and motion are added. Edit any scene, then export." },
      },
      try: "Try it with this idea",
      tour: "Show me on the page",
    },
    exampleIdeas: [
      'Create a video about the history of coffee...',
      'Create a video about the future of AI...',
      'Create a meditation guide video...',
    ],
    prefilled: 'Your idea is ready. Change anything you like, then generate.',
    mismatch: 'Your idea is written in {idea}, but the narration is set to {narration}.',
    mismatchUse: 'Narrate in {idea}',
    mismatchKeep: 'Keep {narration}',
    stockFootage: 'Include stock footage',
    stockFootageHint: 'Combines AI-generated images with real photos & videos from Pexels.',
    choices: {
      more: 'More',
      less: 'Less',
      cast: 'Cast of {n}',
    },
    generate: 'Generate Video',
    generating: 'Generating...',
    premium: 'Premium feature',
    minutesShort: '{n}m',
    secondsShort: '{n}s',
    tryExample: 'Try an example:',
    visualStyle: 'Visual Style',
    narrator: 'Narrator',
    preview: 'Preview {name}',
    stop: 'Stop {name}',
    inspired: "Get inspired by videos made with the AI Video Agent",
    tryThis: 'Try This',
    tryShort: 'Try',
    myProjects: 'My Projects',
    myProjectsHint: 'Manage and edit your generated videos.',
    emptyTitle: 'No AI videos yet',
    emptyDescription: 'Create your first AI-generated video from an idea using the prompt above.',
    emptyCta: 'Write your idea',
    ideaNeeded: 'Write your idea first: a sentence about what the video should be about. The grey text is only an example.',
    ideaTooShort: 'Tell us a little more: at least a short sentence.',
    ideaPick: "Or start from one of these:",
    videoLink: 'That\'s a link to a video. To make shorts from it, use AI Clipping: it finds the best moments and frames them for you. AI Agent makes a new video from an idea you describe.',
    videoLinkClips: 'Make clips from this video',
    videoLinkAnyway: 'Make a video about it anyway',
    useExample: 'Use this example',
    limitTitle: "You've used all your AI videos for now",
    limitBody: '{used} of {limit} used. You get more on {date}, or upgrade to make more today.',
    limitBodyNoDate: '{used} of {limit} used. Upgrade to make more today.',
    limitTitleFree: "No AI videos left",
    limitBodyFree: "Get Pro, or 3 Pro videos paid once, to make one today.",
    inProgress: { title: 'Your video is still being made', open: 'Open it' },
    limitIdeaKept: "Your idea stays in the box until then.",
    limitShare: "Or share one of your videos: when a friend you bring pays, you get a Pro video.",
    limitOpenVideo: 'Your video is ready. Open it to watch and export it.',
    limitCta: 'See plans',
    limitWaitTitle: 'Your video is being made',
    limitWaitBody: 'It counts as one of your videos. You will find it in your videos when it is done.',
    limitWaitCta: 'Follow your video',
    limitError: "You've reached your limit for AI Agent projects. Please upgrade your plan to create more.",
    createError: 'Failed to create project. Please try again.',
    longer: {
      title: 'Unlock longer videos',
      body: 'A pack video runs up to 3 minutes. Go Pro to generate videos up to 10 minutes long.',
      cancel: 'Cancel',
      pricing: 'View Pricing',
    },
    badges: { ai: 'AI Generated', stock: 'Stock Footage + AI' },
    scenarios: {
      cleopatra: { title: 'Queen Cleopatra', prompt: 'Create a video about queen Cleopatra...', subtitle: 'History • Documentary' },
      kyoto: { title: 'Ancient Kyoto', prompt: 'Create a cinematic guide to Kyoto...', subtitle: 'Travel • Cinematic' },
      coffee: { title: 'History of Coffee', prompt: 'Create a video about the history of coffee...', subtitle: 'Education • Documentary' },
      texas: { title: 'Texas Farmer 1850', prompt: 'imaginary vlog of a 1850s american farmer...', subtitle: 'History • Vlog' },
      joan: { title: 'Joan of Arc', prompt: 'the story of joan of arc...', subtitle: 'History • Documentary' },
      dreams: { title: 'Dreams of the Night', prompt: 'Create a video about dreams...', subtitle: 'Psychology • Documentary' },
      history: { title: 'Unknown History', prompt: 'Create a video about unknown history...', subtitle: 'History • Documentary' },
    },
    tour: {
      back: 'Previous',
      close: 'Close',
      last: 'Finish',
      next: 'Next',
      skip: 'Skip tour',
      ideaTitle: 'What is the video about?',
      ideaBody: 'One sentence is enough; the agent writes the script from it.',
      generateTitle: 'One press',
      generateBody: 'Your video takes a few minutes; we email you when it is ready.',
      projectsTitle: 'Your videos',
      projectsBody: 'Every video you make is kept here.',
    },
  },
  // Signed-in app pages moved into the dictionary: account, results, subscription pages
  appShared: {
    projectNotFound: 'Project not found',
    projectNotFoundBody: "The project you're looking for doesn't exist or you don't have access to it.",
    backToProjects: 'Back to Projects',
    errorTitle: 'Error',
    errorBody: 'Something went wrong. Please try again or contact support if the issue persists.',
    previous: 'Previous',
    next: 'Next',
    statuses: {
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      pending: 'Pending',
      deleted: 'Deleted',
    },
  },
  captionsResult: {
    back: 'Back to Auto Caption projects',
    exportJson: 'Export JSON',
    exportJsonHint: 'Download transcript as JSON',
    starting: 'Starting render...',
    startFailed: 'Failed to start rendering',
    timedOut: 'Render timed out',
    complete: 'Render complete!',
    failed: 'Render failed',
    rendering: 'Rendering video with captions...',
    checkFailed: 'Failed to check render status',
    wordsHeard: '{n} words heard',
    livePreview: 'Live preview',
    rendered: 'Rendered',
    custom: 'Custom',
    transcriptPane: 'Transcript',
    previewPane: 'Preview',
    settingsPane: 'Caption settings',
    noVideo: 'The video isn’t available to preview.',
    renderingShort: 'Rendering…',
    renderAgain: 'Render again',
    burnIn: 'Burn captions in',
    videoButton: "Download video",
    transcriptButton: 'Transcript',
    openEditor: 'Open in the full editor',
  },
  account: {
    title: 'Account Settings',
    seoTitle: 'Account Settings - Manage Your Profile & Subscription',
    seoDescription: 'Manage your Clip-Short account settings, view your subscription plan, track usage metrics, and update your billing information.',
    nav: {
      profile: 'Profile',
      subscription: 'Subscription',
      usage: 'Usage',
      notifications: 'Notifications',
    },
    profile: {
      heading: 'Your Information',
      name: 'Name',
      email: 'Email',
      notProvided: 'Not provided',
    },
    notifications: {
      heading: 'Email notifications',
      intro: 'Choose which emails we send to you.',
      loadError: "Couldn't load your email settings.",
      tryAgain: 'Try again',
      saveError: "Couldn't save that. Try again.",
      transactionalLabel: 'Project updates',
      transactionalDescription: 'An email when a project you started is ready.',
      marketingLabel: 'News and offers',
      marketingDescription: 'Occasional product news and offers from Clip-Short.',
    },
    usage: {
      heading: 'Usage Metrics',
      loadError: 'Failed to load usage metrics.',
      currentPeriod: 'Current billing period',
      processingMinutes: 'Video processing minutes',
      bundleLevel: 'Bundle level {quantity}: {quantity} × {per} min = {limit} min total',
      carried: 'Includes {n} carried over from last month',
      aiAgentProjects: 'AI Agent Projects',
      needMore: 'Need more? Upgrade to Pro for higher usage limits.',
      viewPricing: 'View Pricing',
      unavailable: 'Usage data unavailable.',
    },
    subscription: {
      heading: 'Subscription Details',
      refresh: 'Refresh',
      refreshedTitle: 'Subscription updated',
      refreshedBody: 'Successfully refreshed subscription data.',
      errorTitle: 'Error',
      refreshError: 'Failed to refresh subscription data.',
      portalErrorTitle: 'Portal Error',
      portalErrorBody: 'Failed to open subscription management portal. Please try again.',
      billingMonthly: 'Monthly billing',
      billingAnnual: 'Annual billing',
      billingOther: 'Billing: {period}',
      billingUnavailable: 'Billing period unavailable',
      statuses: {
        active: 'Active',
        trialing: 'Free Trial',
        canceled: 'Canceled',
        past_due: 'Past due',
        incomplete: 'Incomplete',
        unpaid: 'Unpaid',
      },
      trialTitle: 'Free trial active',
      trialEndsBefore: 'Your 7-day free trial ends on',
      trialEndsAfter: '.',
      trialNoCharge: "You won't be charged until then. Cancel anytime before the trial ends to avoid charges.",
      legacyTitle: 'Legacy Plan',
      legacyBody: "You're on a grandfathered plan that's no longer available to new customers.",
      legacyKeep: 'You can keep your current pricing and limits, or switch to our new flexible Pro plan anytime.',
      legacyBadge: 'Legacy',
      trialLength: '7-day free trial',
      bundles: '{count} Bundles',
      bundleIncludes: '({hours}h processing + {videos} AI videos)',
      trialBadge: 'Trial',
      cancelPendingTitle: 'Cancellation Pending',
      cancelPendingBody: 'Your subscription will end on {date}. You will lose access to Pro features after this date.',
      limitProcessing: 'Processing',
      limitAiVideos: 'AI Videos',
      limitReprompts: 'Reprompts',
      trialEnds: 'Trial Ends',
      periodEnds: 'Current period ends',
      status: 'Status',
      noRenew: 'Subscription will not renew automatically.',
      cancelsAtEnd: 'Cancels at end of period',
      freeTrial: 'Free Trial',
      openingPortal: 'Opening Portal...',
      manage: 'Manage Subscription',
      noneTitle: 'No active subscription',
      noneBody: 'Upgrade to a Pro plan to access premium features and increase your usage limits.',
      viewPlans: 'View Plans',
    },
  },
  captionControls: {
    fontSize: 'Font & Size',
    fontPlaceholder: 'Font...',
    size: 'Size',
    sizeAria: 'Font Size',
    wordGrouping: 'Word Grouping',
    casePlaceholder: 'Case...',
    outline: 'Outline',
    outlineAria: 'Text Outline',
    shadow: 'Shadow',
    shadowAria: 'Shadow Intensity',
    textAppearance: 'Text Appearance',
    glitch: 'Glitch Effect',
    glitchIntensity: 'Glitch Intensity ({n}%)',
    glitchHint: 'Control glitch effect intensity',
    glitchAria: 'Glitch Intensity',
    glitchStroke: 'Text Stroke Color (for glitch)',
    captionBackground: 'Caption Background',
    speakerColors: 'A colour for each speaker',
    backgroundColor: 'Background Color',
    opacity: 'Opacity ({n}%)',
    opacityAria: 'Background Opacity',
    animationPlaceholder: 'Select animation...',
    animation: 'Animation',
    verticalPosition: 'Vertical Position',
    textColor: 'Text Color',
    highlightColor: 'Highlight Color',
    cases: {
      uppercase: 'UPPERCASE',
      lowercase: 'lowercase',
      capitalize: 'Capitalize',
      normal: 'Normal Case',
    },
    animations: {
      tiktok: 'TikTok Style',
      fade: 'Fade',
      slide: 'Slide Up',
      pop: 'Pop',
      glitch: 'Glitch',
    },
  },
  reframeResult: {
    analysing: 'Working out the framing for {aspect}…',
    analysisFailed: 'The framing analysis failed.',
    liveFramed: 'This is live, and your framing. Rendering makes a file of exactly this.',
    live: 'This is live. Rendering is only needed to download a file.',
    waiting: 'Pick a shape to see it, or render one to download.',
    previewPane: 'Preview',
    sourcePane: 'Source',
    resultPane: 'Reframed',
    settingsPane: 'Reframe settings',
    madeBlack: 'black bars where a shot falls short',
    madeBlur: 'blurred fill where a shot falls short',
    noSource: 'The source isn’t available.',
    sourceCaption: 'The video you sent',
    liveCaption: '{aspect} · live preview',
    resultCaption: 'Reframed to {aspect}',
    shape: 'Shape',
    adjustFraming: 'Adjust framing',
    paddingLabel: 'When a shot can’t fill it',
    paddingUnused: 'Not used: you set the framing, so the file is rendered exactly as previewed.',
    paddingHint: 'Blur fills the edges with the shot itself; black leaves bars.',
    reframeTo: 'Reframe to {aspect}',
    renderFramed: 'Render with your framing',
    reframeAgain: 'Reframe again',
    upToDate: "This is the file you have. Change the shape or the framing to make another.",
    download: 'Download',
  },
  subscriptionResult: {
    backToVideo: 'Back to your video',
    backToWork: 'Back to where you were',
    watermarkNext: 'Export your video again: it comes out with no watermark.',
    successSeoTitle: 'Subscription Success',
    successSeoDescription: 'Your Clip-Short subscription has been successfully activated. Start creating professional short-form videos today.',
    noSession: 'No session ID found in URL',
    notFound: 'Subscription not found. It may take a few moments to process.',
    verifySubscriptionError: 'Error verifying subscription: {message}',
    verifyPaymentError: 'Error verifying payment: {message}',
    unlimited: 'Unlimited',
    processingTitle: 'Processing your subscription',
    processingBody: 'Please wait while we confirm your payment...',
    verificationTitle: 'Subscription Verification',
    verificationError: 'Verification Error',
    backToPricing: 'Back to Pricing',
    trialStarted: 'Your free trial has started!',
    welcome: 'Welcome to {plan}',
    trialAccessTitle: '7 days of full access',
    trialAccessBefore: 'You have full access to all {plan} features until',
    trialAccessAfter: '.',
    trialNoCharge: "You won't be charged until your trial ends. Cancel anytime before then to avoid charges.",
    includedTitle: "What's included in your trial:",
    processingHours: '{hours} hours of video processing per month',
    clippingOne: 'AI clipping of long videos to shorts ({n} reprompting attempt)',
    clippingMany: 'AI clipping of long videos to shorts ({n} reprompting attempts)',
    captioning: 'Auto captioning videos',
    reframing: 'Reframing videos to 9:16, 1:1, 4:5 or 16:9',
    editorRenders: 'Rendering editor projects',
    aiVideos: '{n} AI Agent videos per month',
    imageRegenerations: '{n} image regenerations per project',
    imageEdits: '{n} image edits per project',
    animations: '{n} image-to-video animations per project',
    voiceRegenerations: '{n} voice regenerations per project',
    noWatermark: 'No watermarks on exports',
    editorAccess: 'Access to video editor',
    support: 'Priority email support',
    firstProject: 'Create your first project',
    viewAccount: 'View Account',
    activated: 'Subscription Activated!',
    startCreating: 'Start Creating',
    cancelSeoTitle: "Checkout not finished",
    cancelSeoDescription: "You left the checkout before paying. Nothing was charged. Return to pricing to view our plans.",
    cancelTitle: "Checkout not finished",
    cancelAlertTitle: "Nothing was charged",
    cancelBody: "You left the checkout before paying. Nothing was charged.",
    returnToPricing: 'Return to Pricing',
    goToAccount: 'Go to Account',
    backToMyVideo: "Back to my video",
  },
  projectTimeline: {
    unknown: 'Unknown',
    recent: 'Recently created',
    aspectRatio: 'Aspect Ratio: {value}',
    padding: 'Padding: {value}',
    complete: '{n}% Complete',
  },
  projectPage: {
    captionsSeoTitle: '{title} - Auto Caption Project',
    captionsSeoFallback: 'Auto Caption Project Details',
    captionsSeoDescription: 'View and edit your auto-generated video captions. Customize caption styles, download captioned videos, and manage your transcription project.',
    seoTitle: '{title} - Project Details',
    reframeSeoFallback: 'Video Reframe Project Details',
    seoFallback: 'Project Details',
    reframeSeoDescription: 'View and download your reframed video. Track aspect ratio conversion progress and manage your video reframing project.',
    clippingSeoDescription: 'View and manage your AI clipping project. Track processing progress, view extracted viral moments, and download your generated short-form videos.',
    reprompt: 'Reprompt Video',
    premium: 'Premium',
    promptFoundNothing: 'Prompt {n} (“{prompt}”) didn’t find clips. Try again with a different prompt.',
    repromptTab: 'Reprompt #{n}',
    repromptProcessing: 'Processing reprompt...',
    customPrompt: 'Custom Prompt:',
    repromptFailed: 'Reprompt Failed',
    repromptFailedBody: 'Unfortunately, the reprompt process failed. You can try again with a different prompt.',
  },
  newProject: {
    unreadableLink: "We couldn't read this link. Check that the video is public, or try a YouTube, Twitch, Kick, Drive or X link.",
    channelLink: "That's a channel or playlist link. Paste the link of one video from it.",
    noLinkInText: "There's no video link in that text. Paste the link of one video.",
    twitchNotLive: "That Twitch channel isn't live right now. Paste the link of a past broadcast (a VOD) instead.",
    videoUnavailable: "This video is private, deleted or blocked in some countries. Try another link, or upload the file.",
    noSourceYet: 'Please provide a valid video source (URL or File) and wait for details to load.',
    noDuration: 'Unable to determine video duration. Please try a different video.',
    reframeTooLong: 'Reframe takes up to 30 minutes at a time. Choose a part of 30 minutes or less.',
    partTooShort: 'AI Clipping needs at least 5 minutes to find clips in. Choose a longer part.',
    videoTooShort: 'Your video is less than 5 minutes long. Please choose a longer video to generate clips.',
    noFile: 'Internal error: File source selected but no file present.',
    uploadInProgress: 'Please wait for the file upload to complete.',
    uploadFirst: 'Please upload the selected file before creating the project.',
    notAVideo: 'Invalid file type. Please select a video file.',
    invalidUrl: 'Please enter a valid video URL.',
    infoNotReady: 'Video information is not available yet. Please wait or check the URL.',
    noSource: 'Please provide a video source.',
    metadataFailed: 'Could not retrieve metadata for the selected file. Please try another file.',
    selectFileFirst: 'Please select a file first.',
    uploadFailed: 'File upload failed. Please try again.',
    uploaded: 'File uploaded successfully',
    reframeDemoTop: 'The AI keeps the subject in frame, shot by shot.',
    reframeDemoBottom: 'Vertical, square or wide. Nothing letterboxed.',
  },
  remixStickers: {
    change: 'Change sticker ({label})',
    remove: 'Remove sticker ({label})',
  },
  notFoundPage: {
    title: 'Page not found',
    text: "This page doesn't exist, or it moved. Here is where most people are headed:",
    home: 'Home',
    aiAgent: 'Make a video from an idea',
    tools: 'Free YouTube monetization checker',
    pricing: 'Pricing',
  },
  // The affiliate program: its public page (pages/localized/AffiliatesPage.jsx) and the
  // dashboard in Account (components/Account/AffiliatesSection.jsx). The terms here are the
  // ones the API applies (backend/api/api/services/affiliates.py): keep them equal.
  affiliates: {
    page: {
      seoTitle: 'Affiliate Program: 30% of Every Payment',
      seoDescription: 'Earn 30% of every payment from the creators you bring to Clip-Short, for as long as they stay subscribed. Paid monthly by PayPal, Wise or Vodafone Cash.',
      badge: 'Affiliate program',
      title: 'Earn 30% of every payment, for as long as they stay',
      subtitle: 'Share Clip-Short with the creators who follow you. When someone signs up through your link and subscribes, you get 30% of everything they pay, every month they keep paying.',
      join: 'Become an affiliate',
      facts: {
        rate: '30% of every payment',
        link: 'A 60-day link',
        payout: 'Paid monthly',
      },
      stepsTitle: 'How it works',
      steps: {
        link: { title: 'Get your link', text: 'Join from your account in a minute. Your link carries your own code, like clip-short.com/?via=yourname.' },
        share: { title: 'Share it', text: 'Put it in your video descriptions, your bio, your posts or your group. Anyone who opens it and signs up within 60 days counts as yours.' },
        paid: { title: 'Get paid every month', text: 'You earn 30% of every payment they make. Once your confirmed balance passes US$20, we send it by PayPal, Wise or Vodafone Cash.' },
      },
      termsTitle: 'The terms, plainly',
      terms: [
        '30% of every payment a customer you bring makes, after any discount, for as long as they stay subscribed.',
        'Your link counts for 60 days from their first visit. If they arrived through another affiliate’s link first, the first link wins.',
        'A commission is confirmed 30 days after the payment, when it can no longer be refunded. A refunded payment earns nothing.',
        'We pay confirmed commissions once a month, by PayPal, Wise or Vodafone Cash, once they add up to US$20. Anything less carries over to the next month.',
        'Only new accounts count: someone who already had an account, or already paid, is not a referral, and nobody can refer themselves.',
      ],
      rulesTitle: 'Not allowed',
      rules: [
        'Paid ads on our name: no bidding on “Clip-Short” or its misspellings in Google, YouTube or any other ad platform.',
        'Spam: no unsolicited messages, emails or comments, and no posting your link where it isn’t welcome.',
        'Promises we don’t make: no fake reviews, invented discounts or claims about Clip-Short that aren’t true.',
      ],
      rulesNote: 'If an affiliate breaks these rules, we pause their link and it stops earning.',
      faqTitle: 'Questions',
      faq: {
        who: { q: 'Who can join?', a: 'Anyone with a Clip-Short account. You don’t need to be a paying customer, and there is no minimum audience.' },
        track: { q: 'How do you know someone came from me?', a: 'Your link carries your code. Their browser keeps it for 60 days, and it is attached to them when they create their account. Your dashboard shows the clicks, the sign-ups and every commission.' },
        when: { q: 'When do I get paid?', a: 'Each commission is confirmed 30 days after the payment. Once a month we send everything confirmed, as long as it adds up to at least US$20.' },
        how: { q: 'How is the money sent?', a: 'By PayPal, Wise or Vodafone Cash, to the account you give us. You can change it any time in your dashboard.' },
        refund: { q: 'What if a customer gets a refund?', a: 'A refunded payment earns no commission. That is why commissions are confirmed only after 30 days.' },
        life: { q: 'Is it really for as long as they stay?', a: 'Yes. Every monthly or yearly renewal of a customer you brought earns you 30% again, for as long as they keep paying and the program runs.' },
      },
      ctaTitle: 'Ready to share Clip-Short?',
      ctaText: 'Getting your link takes a minute.',
    },
    dashboard: {
      nav: 'Affiliates',
      heading: 'Affiliate program',
      intro: 'Earn 30% of every payment from the people you bring, for as long as they stay subscribed.',
      readTerms: 'Read the terms',
      joinTitle: 'Where should we send your money?',
      method: 'Payout method',
      methods: {
        paypal: 'PayPal',
        wise: 'Wise',
        vodafone_cash: 'Vodafone Cash',
        other: 'Other',
      },
      details: {
        paypal: 'Your PayPal email',
        wise: 'Your Wise email',
        vodafone_cash: 'Your Vodafone Cash number',
        other: 'How should we pay you?',
      },
      placeholders: {
        paypal: 'you@example.com',
        wise: 'you@example.com',
        vodafone_cash: '010 1234 5678',
        other: 'The account and anything we need to send it',
      },
      agree: 'By joining you accept the program’s terms: no paid ads on our name, and no spam.',
      join: 'Get my link',
      joining: 'Joining…',
      errors: {
        invalid_payout_details: 'That doesn’t look right for this payout method. Check it and try again.',
        invalid_payout_method: 'Choose how you want to be paid.',
        generic: 'Something went wrong. Try again.',
      },
      loadError: 'We couldn’t load your affiliate account.',
      tryAgain: 'Try again',
      yourLink: 'Your link',
      linkHint: 'Adding ?via={code} to any clip-short.com page works too.',
      copy: 'Copy',
      copied: 'Copied',
      clicks: 'Visits',
      signups: 'Sign-ups',
      customers: 'Paying customers',
      pending: 'Pending',
      pendingHint: 'Confirmed 30 days after each payment',
      approved: 'Confirmed',
      approvedHint: 'Paid monthly from US$20',
      paid: 'Paid to you',
      noMoney: 'Nothing yet. A commission shows up here as soon as a customer you brought pays.',
      recentTitle: 'Commissions',
      columns: {
        date: 'Payment',
        amount: 'They paid',
        commission: 'You earn',
        status: 'Status',
      },
      statuses: {
        pending: 'Pending until {date}',
        approved: 'Confirmed',
        paid: 'Paid',
        void: 'Refunded',
      },
      payoutTitle: 'Payout details',
      change: 'Change',
      save: 'Save',
      saving: 'Saving…',
      cancel: 'Cancel',
      paused: 'Your link is paused: it isn’t bringing in new customers or earning new commissions. Write to us if you think this is a mistake.',
    },
  },
  renderStage: {
    preparing: 'Getting your video ready…',
    scene: 'Getting scene {n} of {total} ready…',
    clip: 'Getting clip {n} of {total} ready…',
    frames: 'Making your video · {percent}%',
    finishing: 'Putting the finishing touches…',
    saving: 'Saving your video · {percent}%',
    done: 'Done',
  },
};
